<template>
  <section
    class="configure-document entity-edit-page !bg-container-background rounded-xl heightClass"
    id="drag-template-background"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :class="{ mobile: getIsMobile, 'is-close-RS': !getIsRSOpen }"
  >
    <div
      class="flow-top-bar bg-container-background border-b border-page-border sticky top-0 z-[3]"
    >
      <div class="left-side" id="entityEditScreen">
        <div class="close-icon">
          <el-tooltip content="Back" placement="bottom">
            <el-button
              type="text"
              class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
              @click="goBack"
              style="display: flex"
            >
              <img
                src="@/assets/img/icons/new/left-back-icon.svg"
                alt=""
                class="!size-3 group-hover:scale-105"
              />
            </el-button>
          </el-tooltip>
        </div>
        <el-form :class="!this.isEdit ? 'form-title hide-title' : 'form-title'">
          <el-input
            size="mini"
            v-model="entityName"
            placeholder="Enter Entity Title"
            class="input-type-one !text-sm"
          ></el-input>
          <p class="error" v-if="!entityName"></p>
        </el-form>
      </div>
      <div
        class="w-[60%]"
        :class="getIsMobile ? '' : 'flow-top-bar-middle-area document-flow-wrapper'"
        id="entityStepper"
      >
        <el-steps
          finish-status="success"
          :space="300"
          align-center
          class="document-flow"
          :style="getIsMobile ? 'margin-top:-12px' : 'mb-1'"
          :active="activeStep"
        >
          <el-step title="Builder" @click.native="builderStep(0)"></el-step>
          <el-step title="Primary Fields" @click.native="builderStep(1)"></el-step>

          <el-step title="Relationships" @click.native="builderStep(2)"></el-step>
          <el-step title="Customization" @click.native="builderStep(3)"></el-step>
          <el-step title="Actions" @click.native="builderStep(4)"></el-step>
        </el-steps>
      </div>
      <div :class="getIsMobile ? '' : 'flow-top-bar-right-area'">
        <div style="justify-content: right; display: flex; align-items: center">
          <el-tooltip content="Settings" placement="bottom">
            <button
              @click="openNewEntityModal"
              class="!bg-transparent !border !border-black/20 !mr-[0.8rem] !py-[3px] !px-1.5 !rounded-sm hover:!bg-gray-100 !h-fit w-[30px]"
              type="text"
            >
              <img src="@/assets/img/icons/new/settings-icon.svg" alt="" class="!size-4" />
            </button>
          </el-tooltip>
          <el-tooltip :content="getIsMobile ? 'Close' : 'Save & close'" placement="bottom">
            <el-button
              :underline="false"
              style="background-color: var(--brand-500) !important"
              @click="updateEntityData(true)"
              :class="
                getIsMobile
                  ? ''
                  : ' !text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit'
              "
              type="button"
              v-if="isEdit && this.activeStep == 1"
              size="mini"
            >
              {{ getIsMobile ? 'Close' : 'Save & close' }}
            </el-button>
          </el-tooltip>
          <el-button
            :underline="false"
            size="mini"
            style="background-color: var(--brand-500) !important"
            @click="saveEntity"
            class="mr-1!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit !bg-brand-500 !text-brand-500 !border-brand-500"
            type="button"
            v-if="!isEdit && this.activeStep != 2"
          >
            {{ getIsMobile ? 'Save' : 'Save &amp; Next' }}
          </el-button>

          <el-button
            :underline="false"
            @click="updateEntityData(false)"
            style="background-color: var(--brand-500) !important"
            :class="
              getIsMobile
                ? ''
                : ' mr-1 !text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit !border !border-brand-500'
            "
            type="button"
            size="mini"
            v-else-if="isEdit && this.activeStep != 4"
          >
            {{ getIsMobile ? 'Update' : 'Update & Next' }}
          </el-button>
          <el-button
            :underline="false"
            style="background-color: var(--brand-500) !important"
            @click="checkAutomation"
            class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit !bg-brand-500 !text-brand-500 !border-brand-500"
            type="button"
            size="mini"
            v-else-if="this.activeStep == 4"
          >
            Done
          </el-button>

          <div
            class="action-wrapper-type-two float-right !mx-0"
            :style="getIsMobile ? 'margin-top:-45px' : ''"
          >
            <el-button
              title="Open"
              slot="reference"
              class="!bg-transparent !border !border-black/20 !py-1.5 !px-2 !rounded-sm hover:!bg-gray-100 !h-fit"
              type="text"
              size="mini"
              v-on:click="openRightSideBar()"
              :disabled="getIsRSOpen"
              v-if="!getIsRSOpen && activeStep === 0"
            >
              &lt;&lt;
            </el-button>
            <el-button
              title="Close"
              slot="reference"
              size="mini"
              class="!bg-transparent !border !border-black/20 !py-1.5 !px-2 !rounded-sm hover:!bg-gray-100 !h-fit"
              type="text"
              v-on:click="closeRightSideBar()"
              v-if="getIsRSOpen && activeStep === 0"
            >
              &gt;&gt;
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-row style="margin-top: 10px">
      <DropTemplates
        v-if="activeStep === 0"
        :allSelectedEntity="selectedEntity"
        :allTemplates="allTemplates"
        :isSubmit="isSubmit"
        :isEdit="isEdit"
        v-on:getTemplates="updateEntityTemplates"
        :entityType="entity_type"
      ></DropTemplates>
      <div class="dragAndDrop" v-if="activeStep === 1">
        <el-row :gutter="10">
          <el-col :span="12">
            <div style="text-align: left" class="dropBox">
              <div class="px-2">
                <h3 class="head font-normal !m-0">All Fields</h3>
                <p class="text !m-0 !pt-1" v-if="!draggableFields.length">
                  The fields list is empty
                </p>
              </div>
              <el-divider class="!my-2 !bg-gray-100"></el-divider>
              <draggable
                class="list-group"
                tag="ul"
                :list="draggableFields"
                v-bind="dragOptions"
                :move="onMove"
                @start="isDragging = true"
                @end="isDragging = false"
              >
                <transition-group type="transition" :name="'flip-list'" class="contain-length">
                  <li class="list-group-item" v-for="element in draggableFields" :key="element.key">
                    {{ element.label }}
                  </li>
                </transition-group>
              </draggable>
              <div style="margin-bottom: 1rem"></div>
            </div>
          </el-col>

          <el-col :span="12">
            <div style="text-align: left" class="dropBox">
              <div class="px-2">
                <h3 class="head !m-0">Primary Fields</h3>
                <p class="text !m-0 !pt-1" v-if="!primaryFields.length">
                  Drag the fields from the left panel and drop here to add them
                </p>
              </div>

              <el-divider class="!my-2 !bg-gray-100"></el-divider>
              <draggable element="span" v-model="primaryFields" v-bind="dragOptions" :move="onMove">
                <transition-group name="no" class="list-group" tag="ul">
                  <li class="list-group-item" v-for="element in primaryFields" :key="element.key">
                    <el-checkbox
                      v-if="
                        selectedEntity &&
                        selectedEntity[0] &&
                        selectedEntity[0].template_id &&
                        element.template_id == selectedEntity[0].template_id
                      "
                      v-model="element.is_primary"
                      @change="updatedPrimaryFields(element.key)"
                    >
                      {{ element.label }}
                    </el-checkbox>
                    <p v-else>
                      {{ element.label }}
                    </p>
                  </li>
                </transition-group>
              </draggable>
              <div style="margin-bottom: 1rem"></div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div
        id="relationshipStep"
        class="relationships !p-3 !border border-gray-100 rounded-xl !m-2"
        v-if="activeStep === 2"
      >
        <el-row>
          <el-col :span="24">
            <el-form
              :inline="true"
              :model="newRelationship"
              class="demo-form-inline"
              label-position="left"
            >
              <div class="flex items-center !gap-3 !mb-3">
                <el-form-item class="!m-0">
                  <el-select
                    v-model="newRelationship.parent_entity_id"
                    disabled
                    filterable
                    size="mini"
                  >
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                  <p class="error" v-if="getErrors && getErrors.parent_entity_id">
                    {{ getErrors.parent_entity_id }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0" label="Has">
                  <el-select v-model="newRelationship.child_relation_type" filterable size="mini">
                    <el-option value="MANY">MANY</el-option>
                    <el-option value="ONE">ONE</el-option>
                  </el-select>
                  <p class="error" v-if="getErrors && getErrors.child_relation_type">
                    {{ getErrors.child_relation_type }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0">
                  <el-select
                    v-model="newRelationship.child_entity_id"
                    @change="checkEntitiesParentTitle"
                    filterable
                    size="mini"
                  >
                    <el-option
                      v-for="(entity, index) of otherEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>

                  <p class="error" v-if="getErrors && getErrors.child_entity_id">
                    {{ getErrors.child_entity_id }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0" label="As">
                  <el-input
                    v-model="newRelationship.child_relation_title"
                    size="mini"
                    placeholder="Enter name"
                  ></el-input>
                  <p class="error" v-if="getErrors && getErrors.child_relation_title">
                    {{ getErrors.child_relation_title }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0">
                  <el-checkbox v-model="newRelationship.is_bidirectional"></el-checkbox>
                </el-form-item>
              </div>

              <div class="flex items-center !gap-3 !mb-3" v-if="newRelationship.is_bidirectional">
                <el-form-item class="!m-0">
                  <el-select v-model="newRelationship.child_entity_id" disabled size="mini">
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                  <p class="error" v-if="getErrors && getErrors.child_entity_id">
                    {{ getErrors.child_entity_id }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0" label="Has">
                  <el-select v-model="newRelationship.parent_relation_type" size="mini">
                    <el-option value="MANY">MANY</el-option>
                    <el-option value="ONE">ONE</el-option>
                  </el-select>
                  <p class="error" v-if="getErrors && getErrors.parent_relation_type">
                    {{ getErrors.parent_relation_type }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0">
                  <el-select v-model="newRelationship.parent_entity_id" disabled size="mini">
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                  <p class="error" v-if="getErrors && getErrors.parent_entity_id">
                    {{ getErrors.parent_entity_id }}
                  </p>
                </el-form-item>
                <el-form-item class="!m-0" label="As">
                  <el-input
                    v-model="newRelationship.parent_relation_title"
                    size="mini"
                    placeholder="Enter name"
                  ></el-input>
                  <p class="error" v-if="getErrors && getErrors.parent_relation_title">
                    {{ getErrors.parent_relation_title }}
                  </p>
                </el-form-item>
              </div>

              <p class="error" v-if="getErrors && getErrors.critical_error">
                {{ getErrors.critical_error }}
              </p>

              <el-button
                style="background-color: var(--brand-500) !important"
                class="!text-white !px-4 !py-1.5 !font-normal !rounded-md !text-xs 2xl:text-smd !mt-2 !border-brand-500"
                @click="addNewRelationship"
                type="button"
                size="mini"
                :disabled="!newRelationship.child_entity_id"
              >
                Add Relationship
              </el-button>
            </el-form>
          </el-col>
        </el-row>
        <div class="!mb-4 !mt-5">
          <h3 class="text-sm 2xl:text-base font-normal !text-[#333]">
            Entity Relationships From Templates
          </h3>
          <el-tooltip content="Sync relationships from templates" placement="bottom">
            <el-button
              @click="fetchExistedRelationships"
              class="!bg-transparent !border !border-black/20 !text-[#333] hover:!bg-gray-100 !px-4 !py-1.5 !font-normal !rounded-md !text-xs 2xl:text-smd"
            >
              Sync Relationships
            </el-button>
          </el-tooltip>
        </div>
        <el-row gutter="20">
          <el-col :span="12">
            <el-table :data="newRelationshipsData" style="width: 100%" border>
              <el-table-column prop="parent_entity_id" label="Entity" width="140">
                <template slot-scope="scope">
                  <el-select
                    v-model="newRelationshipsData[scope.$index].parent_entity_id"
                    disabled
                    size="mini"
                  >
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="child_relation_type" label="Has" width="100">
                <template slot-scope="scope">
                  {{ newRelationshipsData[scope.$index].child_relation_type }}
                </template>
              </el-table-column>

              <el-table-column prop="child_entity_id" label="Child Entity" width="140">
                <template slot-scope="scope">
                  <el-select
                    v-model="newRelationshipsData[scope.$index].child_entity_id"
                    disabled
                    size="mini"
                  >
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="child_relation_title" label="As" width="140">
                <template slot-scope="scope">
                  <el-input
                    v-model="newRelationshipsData[scope.$index].child_relation_title"
                    size="mini"
                    placeholder="Enter name"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="12">
            <el-table :data="newRelationshipsData" style="width: 100%" border>
              <el-table-column prop="parent_entity_id" label="Entity" width="140">
                <template slot-scope="scope">
                  <el-select
                    v-model="newRelationshipsData[scope.$index].child_entity_id"
                    disabled
                    size="mini"
                  >
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="child_relation_type" label="Has" width="140">
                <template slot-scope="scope">
                  <el-select
                    v-model="newRelationshipsData[scope.$index].parent_relation_type"
                    size="mini"
                  >
                    <el-option label="MANY" value="MANY"></el-option>
                    <el-option label="ONE" value="ONE"></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="child_entity_id" label="Child Entity" width="140">
                <template slot-scope="scope">
                  <el-select
                    v-model="newRelationshipsData[scope.$index].parent_entity_id"
                    disabled
                    size="mini"
                  >
                    <el-option
                      v-for="(entity, index) of allEntities"
                      :label="entity.name"
                      :key="index"
                      :value="entity._id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="parent_relation_title" label="As" width="120">
                <template slot-scope="scope">
                  <el-input
                    v-model="newRelationshipsData[scope.$index].parent_relation_title"
                    size="mini"
                    placeholder="Enter name"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="parent_relation_title" label="Actions" width="100">
                <template slot-scope="scope">
                  <el-button
                    icon="el-icon-check"
                    @click="addLimit(scope.$index)"
                    type="success"
                    size="mini"
                    class="!bg-brand-500 !text-white !px-3 !py-1.5 hover:!bg-brand-500 hover:!text-white !border-brand-500"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="!mt-4">
          <h3 class="text-sm 2xl:text-base font-normal !text-[#333]">All Entity Relationships</h3>
          <el-row gutter="20">
            <el-col :span="12">
              <el-table :data="relationshipsData" style="width: 100%" border>
                <el-table-column prop="parent_entity_id" label="Entity" width="160">
                  <template slot-scope="scope">
                    <el-select
                      v-if="relationshipsData[scope.$index].owner_type == 'PARENT'"
                      v-model="relationshipsData[scope.$index].parent_entity_id"
                      disabled
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-if="relationshipsData[scope.$index].owner_type == 'CHILD'"
                      v-model="relationshipsData[scope.$index].child_entity_id"
                      disabled
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="child_relation_type" label="Has" width="80">
                  <template slot-scope="scope">
                    <span v-if="relationshipsData[scope.$index].owner_type == 'PARENT'">
                      {{ relationshipsData[scope.$index].child_relation_type }}
                    </span>
                    <span v-if="relationshipsData[scope.$index].owner_type == 'CHILD'">
                      {{ relationshipsData[scope.$index].parent_relation_type }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column prop="child_entity_id" label="Child Entity" width="160">
                  <template slot-scope="scope">
                    <el-select
                      v-model="relationshipsData[scope.$index].child_entity_id"
                      disabled
                      v-if="relationshipsData[scope.$index].owner_type == 'PARENT'"
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>

                    <el-select
                      v-model="relationshipsData[scope.$index].parent_entity_id"
                      disabled
                      v-if="relationshipsData[scope.$index].owner_type == 'CHILD'"
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column prop="child_relation_title" label="As" width="140">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="el-tooltips"
                      :content="relationshipsData[scope.$index].child_relation_title"
                      placement="top"
                    >
                      <span
                        v-if="relationshipsData[scope.$index].owner_type == 'PARENT'"
                        class="truncate-text"
                      >
                        {{
                          relationshipsData[scope.$index].child_relation_title | truncate(10, '...')
                        }}
                      </span>
                    </el-tooltip>
                    <span
                      v-if="relationshipsData[scope.$index].owner_type == 'CHILD'"
                      class="truncate-text"
                    >
                      {{ relationshipsData[scope.$index].parent_relation_title }}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12">
              <el-table :data="relationshipsData" style="width: 100%" border>
                <el-table-column prop="parent_entity_id" label="Entity" width="160">
                  <template
                    slot-scope="scope"
                    v-if="relationshipsData[scope.$index].is_bidirectional"
                  >
                    <el-select
                      v-if="relationshipsData[scope.$index].owner_type == 'CHILD'"
                      v-model="relationshipsData[scope.$index].parent_entity_id"
                      disabled
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-if="relationshipsData[scope.$index].owner_type == 'PARENT'"
                      v-model="relationshipsData[scope.$index].child_entity_id"
                      disabled
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <b>-</b>
                  </template>
                </el-table-column>
                <el-table-column prop="child_relation_type" label="Has" width="80">
                  <template
                    slot-scope="scope"
                    v-if="relationshipsData[scope.$index].is_bidirectional"
                  >
                    <span v-if="relationshipsData[scope.$index].owner_type == 'CHILD'">
                      {{ relationshipsData[scope.$index].child_relation_type }}
                    </span>
                    <span v-if="relationshipsData[scope.$index].owner_type == 'PARENT'">
                      {{ relationshipsData[scope.$index].parent_relation_type }}
                    </span>
                  </template>
                  <template v-else>
                    <b>-</b>
                  </template>
                </el-table-column>

                <el-table-column prop="child_entity_id" label="Child Entity" width="180">
                  <template
                    slot-scope="scope"
                    v-if="relationshipsData[scope.$index].is_bidirectional"
                  >
                    <el-select
                      v-model="relationshipsData[scope.$index].child_entity_id"
                      disabled
                      v-if="relationshipsData[scope.$index].owner_type == 'CHILD'"
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>

                    <el-select
                      v-model="relationshipsData[scope.$index].parent_entity_id"
                      disabled
                      v-if="relationshipsData[scope.$index].owner_type == 'PARENT'"
                    >
                      <el-option
                        v-for="(entity, index) of allEntities"
                        :label="entity.name"
                        :key="index"
                        :value="entity._id"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <b>-</b>
                  </template>
                </el-table-column>

                <el-table-column prop="child_relation_title" label="As" width="100">
                  <template
                    slot-scope="scope"
                    v-if="relationshipsData[scope.$index].is_bidirectional"
                  >
                    <span
                      v-if="relationshipsData[scope.$index].owner_type == 'CHILD'"
                      class="truncate-text"
                    >
                      {{ relationshipsData[scope.$index].child_relation_title }}
                    </span>
                    <el-tooltip
                      class="el-tooltips"
                      :content="relationshipsData[scope.$index].parent_relation_title"
                      placement="top"
                    >
                      <span
                        v-if="relationshipsData[scope.$index].owner_type == 'PARENT'"
                        class="truncate-text"
                      >
                        {{
                          relationshipsData[scope.$index].parent_relation_title | truncate(8, '...')
                        }}
                      </span>
                    </el-tooltip>
                  </template>
                  <template v-else>
                    <b>-</b>
                  </template>
                </el-table-column>
                <el-table-column prop="parent_relation_title" label="Actions" width="100">
                  <template slot-scope="scope">
                    <el-button
                      class="!bg-transparent !border !border-transparent hover:!border-[#EB5757] !py-1 !px-1.5 !rounded-sm hover:!bg-[#EB5757]/10 !h-fit transition-all duration-300 ease-in-out"
                      @click="deleteRelationship(scope.row._id)"
                      type="text"
                      size="mini"
                    >
                      <img src="@/assets/img/icons/new/delete-icon.svg" alt="" class="!size-3" />
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row>
    <div class="actions !p-3 rounded-[0_0_12px_12px]" v-if="activeStep == 4" id="main-playboard">
      <EntityActions :currentEntity="currentEntity" :saveClicked="saveClicked"></EntityActions>
    </div>
    <div class="view-configuration !px-3" v-if="activeStep == 3">
      <EntityCustomizations
        :currentEntity="currentEntity"
        @refresh="fetchEntityId"
      ></EntityCustomizations>
    </div>
    <dialog-component
      :title="'Entity Information'"
      :visible="newEntityModal"
      :containerWidth="getIsMobile ? '100%' : '75%'"
      :containerHeight="getIsMobile ? '90vh' : '80vh'"
      class="doc-modal entity-information-popup"
      v-loading="modalLoading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      @before-close="destroyCreateModal"
    >
      <div>
        <div
          v-loading="docLoading"
          element-loading-text="Generating document template, please wait..."
          element-loading-spinner="el-icon-loading"
        >
          <div class="!px-3 pb-3">
            <span class="content-spacing">
              <br />
              <label>Name :</label>
              <el-input type="text" placeholder="Title" v-model="entityName" size="mini"></el-input>
              <br />
            </span>
            <br />
            <span class="content-spacing">
              <label>Description :</label>
              <el-input
                type="textarea"
                placeholder="Description"
                v-model="description"
                size="mini"
              ></el-input>
            </span>
            <br />
            <br />
            <span class="mt-1 content-spacing">
              <el-row>
                <el-col :span="8">
                  <label>Printing settings :</label>
                  <el-select
                    placeholder="Document template"
                    v-model="printingDocuments"
                    multiple
                    size="mini"
                    clearable
                    collapse-tags
                    style="width: 90%"
                  >
                    <el-option
                      v-for="(doc, i) in allDocumentTemplates"
                      :key="i + '_document'"
                      :label="doc.title"
                      :value="doc.configurable_document_id"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <label>Default document :</label>
                  <el-select
                    placeholder="Default document template"
                    v-model="defaultPrintingDocument"
                    size="mini"
                    clearable
                    style="width: 90%"
                  >
                    <el-option
                      v-for="(doc, i) in allDocumentTemplates.filter(
                        (e) =>
                          printingDocuments &&
                          printingDocuments.indexOf(e.configurable_document_id) !== -1
                      )"
                      :key="i + '_document_default'"
                      :label="doc.title"
                      :value="doc.configurable_document_id"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <label>Export Entity Document :</label>
                  <el-select
                    placeholder="Export Entity Document Template"
                    v-model="exportPrintingDocument"
                    size="mini"
                    clearable
                    style="width: 90%"
                  >
                    <el-option
                      v-for="(doc, i) in allDocumentTemplates.filter(
                        (e) =>
                          printingDocuments &&
                          printingDocuments.indexOf(e.configurable_document_id) !== -1
                      )"
                      :key="i + '_document_export'"
                      :label="doc.title"
                      :value="doc.configurable_document_id"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </span>
            <br />
            <div class="mt-1">
              <i class="el-icon-info"></i>
              <label>
                To print the entity data in a document, please click on the "Generate Document
                Template" button or select a existed document template in the above printing
                settings.
              </label>
              <el-button
                @click="createDocumentTemplate"
                type="button"
                style="background-color: var(--brand-500) !important"
                class="mt-1 !text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit !bg-brand-500 !text-brand-500 !border-brand-500"
                size="mini"
              >
                Generate Document template
              </el-button>
            </div>
            <div class="mb-4 mt-1" v-if="getCustomMsgData && defaultPrintingDocument">
              <label>Customized Document Name:</label>
              <div style="position: relative">
                <div
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: 1px solid black;
                    z-index: 1;
                  "
                ></div>
                <CustomEntityMention
                  :entity_id="entityId"
                  :data="getCustomMsgData"
                  :fromPdfPrinting="true"
                  :allTemplates="allTemplates"
                  style="position: relative; z-index: 2"
                ></CustomEntityMention>
              </div>
            </div>
            <div class="mt-1">
              <el-row>
                <el-col :span="8">
                  <label>Default email template :</label>
                  <el-select
                    placeholder="email template"
                    v-model="defaultEmailTemplate"
                    size="mini"
                    clearable
                    collapse-tags
                    style="width: 90%"
                  >
                    <el-option
                      v-for="(doc, i) in getEmailTemplates('ENTITY')"
                      :key="i + '_document'"
                      :label="doc.name"
                      :value="doc._id"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <label>Default header footer template :</label>
                  <el-select
                    placeholder="email template"
                    v-model="defaultParentTemplate"
                    size="mini"
                    clearable
                    collapse-tags
                    style="width: 90%"
                  >
                    <el-option
                      v-for="(doc, i) in getEmailTemplates('PARENT')"
                      :key="i + '_document'"
                      :label="doc.name"
                      :value="doc._id"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <br />
            <el-row>
              <el-col :span="12">
                <span class="content-spacing">
                  <br />
                  <label>Entity Type</label>
                  <el-radio-group
                    v-model="entity_type"
                    size="mini"
                    fill="#323b6a"
                    style="margin-top: 0.5rem; margin-left: 0.5rem"
                    class="entity-type-radio"
                    :disabled="hasData"
                    @change="checkIndividualEntity"
                  >
                    <el-radio-button
                      label="GENERAL"
                      @click.native="isAccount = false"
                    ></el-radio-button>
                    <el-radio-button
                      label="BUSINESS"
                      @click.native="isAccount = true"
                    ></el-radio-button>
                    <el-radio-button
                      label="INDIVIDUAL"
                      @click.native="isAccount = true"
                    ></el-radio-button>
                  </el-radio-group>
                  <br />
                  <span v-if="hasData" style="font-size: 12px; color: #e6a23c">
                    Can't change entity type, some {{ entityName }} data already existed.
                  </span>
                </span>
              </el-col>
              <el-col :span="12" v-if="!this.$route.query.group">
                <span class="content-spacing">
                  <br />
                  <label>Groups:</label>
                  <el-row>
                    <el-col :span="12">
                      <el-select
                        v-model="entityGroupsData"
                        placeholder="Select Group"
                        multiple
                        filterable
                        collapse-tags
                        @change="checkSelection"
                      >
                        <el-option
                          v-for="(item, index) of getAllEntityGroupsData"
                          v-bind:key="index"
                          :label="item.name"
                          :value="item._id"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="1">
                      <el-tooltip content="Add New Group" placement="top" effect="light">
                        <i class="el-icon-circle-plus-outline" @click="addGroupPopUP"></i>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <span v-if="!isValidSelection" style="color: red">
                    Please select at least one group!
                  </span>
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="20" align="middle" class="mt-1">
              <el-col :span="3" v-if="entity_type == 'GENERAL'">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="If selected, the entity data will be saved in draft mode. You can filter and finalize it later before it is added to the entity."
                  placement="top"
                >
                  <el-checkbox v-model="isSaveAsDraft">SaveAsDraft</el-checkbox>
                </el-tooltip>
              </el-col>
              <el-col :span="8">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="If selected, multiple users cannot edit the entity data at the same time."
                  placement="top"
                >
                  <el-checkbox v-model="isRestrictMultiple">
                    Allow single-user editing at a time to edit
                  </el-checkbox>
                </el-tooltip>
              </el-col>
              <el-col :span="12" v-if="isRestrictMultiple">
                <div style="display: flex; gap: 8px">
                  <span>Lock Duration:</span>
                  <el-input-number v-model="lockDurationValue" :min="1" style="width: 40%" />
                  <el-select v-model="lockDurationUnit" placeholder="Unit" style="width: 20%">
                    <el-option label="Minutes" value="MINUTES" />
                    <el-option label="Hours" value="HOURS" />
                    <el-option label="Days" value="DAYS" />
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <br />
            <hr />
            <el-row :gutter="30" v-if="entity_type !== 'INDIVIDUAL'">
              <el-col :span="12">
                <label>QR Scan Settings</label>
                <el-select
                  placeholder="QR code main field"
                  v-model="qrCodeImportField"
                  :filterable="true"
                  :clearable="true"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="(item, index) of allEntityFields.filter(
                      (e) => e.input_type == 'ENTITY' && e.properties.qr_code_scanning
                    )"
                    v-bind:key="item.key + '_' + index"
                    :label="item.template_name + '-' + item.label"
                    :value="item.template_key"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <label>QR Value Match With</label>
                <br />
                <el-radio-group v-model="qrCodeImportField_search_type" size="mini">
                  <el-radio-button label="Record Id"></el-radio-button>
                  <el-radio-button label="Fields"></el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="4" v-if="qrCodeImportField_search_type == 'Fields'">
                <label>QR Scan Settings</label>
                <el-select
                  placeholder="QR code main field"
                  v-model="qrCodeImportField_search_field"
                  :filterable="true"
                  :clearable="true"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="(item, index) of allEntityFields.find(
                      (e) =>
                        e.input_type == 'ENTITY' &&
                        e.properties.qr_code_scanning &&
                        e.template_key == this.qrCodeImportField
                    )?.primary_fields || []"
                    v-bind:key="item + '_' + index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mt-1 mb-1" v-if="entity_type !== 'INDIVIDUAL' && qrCodeImportField">
              <div>
                <div>
                  <span>Success title :</span>
                  <el-input
                    v-model="qrCodeImportField_success_title"
                    class="mr-2 ml-6"
                    :style="getIsMobile ? 'width:300px' : 'width: 345px'"
                    placeholder="Enter Title"
                  ></el-input>
                </div>
                <div class="mt-1">
                  <span>Success Message :</span>
                  <el-input
                    v-model="qrCodeImportField_custom_message"
                    type="textarea"
                    class="mr-2 ml-2"
                    :style="getIsMobile ? 'width:300px' : 'width: 345px'"
                    maxlength="998"
                    rows="2"
                    show-word-limit
                    placeholder="Enter message"
                  ></el-input>
                  <el-select
                    v-model="copyField"
                    placeholder="Select Field to copy"
                    filterable
                    collapse-tags
                    @change="copyURL"
                    :style="getIsMobile ? 'width:300px;margin-top:5px' : 'width: 350px'"
                    class="Select-in-Email-Templates"
                  >
                    <el-option
                      v-for="(item, index) of getValidFields()"
                      v-bind:key="index"
                      :label="item.label"
                      :value="item.label"
                      :style="getIsMobile ? 'width: 300px;margin-left: 10rem' : ''"
                    >
                      {{ item.label }} ({{ item.input_type }})
                      <a @click.stop="pushToErrorMessage(item.label, 'success')">
                        <i class="el-icon-right"></i>
                      </a>
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="mt-2">
                <div>
                  <span>Error Title :</span>
                  <el-input
                    v-model="qrCodeImportField_error_title"
                    class="mr-2 ml-6"
                    :style="getIsMobile ? 'width:300px' : 'width: 345px'"
                    placeholder="Enter Title"
                  ></el-input>
                </div>
                <div class="mt-1">
                  <span>Error Message :</span>
                  <el-input
                    v-model="qrCodeImportField_error_message"
                    type="textarea"
                    class="mr-2 ml-4"
                    :style="getIsMobile ? 'width:300px' : 'width: 345px'"
                    maxlength="998"
                    rows="2"
                    show-word-limit
                    placeholder="Enter message"
                  ></el-input>
                  <el-select
                    v-model="copyField"
                    placeholder="Select Field to copy"
                    filterable
                    collapse-tags
                    @change="copyURL"
                    :style="getIsMobile ? 'width:300px;margin-top:5px' : 'width: 350px'"
                    class="Select-in-Email-Templates"
                  >
                    <el-option
                      v-for="(item, index) of getValidFields()"
                      v-bind:key="index"
                      :label="item.label"
                      :value="item.label"
                      :style="getIsMobile ? 'width: 300px;margin-left: 10rem' : ''"
                    >
                      {{ item.label }} ({{ item.input_type }})
                      <a @click.stop="pushToErrorMessage(item.label)">
                        <i class="el-icon-right"></i>
                      </a>
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-row>
            <el-row
              v-if="entity_type == 'INDIVIDUAL' || entity_type == 'BUSINESS'"
              :gutter="30"
              class="mb-2"
            >
              <el-col :span="24">
                <el-checkbox v-model="checkedHasLogin">
                  This entity has login for all its contacts
                </el-checkbox>
                <el-checkbox v-model="checked_newuser">Allow new user to login</el-checkbox>
                <el-checkbox v-model="is_mfa">Enable two-factor login (OTP)</el-checkbox>
              </el-col>
              <el-col :span="24" v-if="checked_newuser">
                <el-alert
                  v-if="getEntityDataById?.entity_code"
                  type="success"
                  :description="getLoginDescription"
                  show-icon
                  :closable="false"
                >
                  <template #title>
                    <span>{{ getLoginUrl }}</span>
                    <el-button
                      icon="el-icon-copy-document"
                      @click="copyLoginURL(getLoginUrl)"
                      size="mini"
                      type="text"
                      class="ml-1"
                      style="padding: 0; margin-left: 5px"
                    ></el-button>
                  </template>
                </el-alert>
              </el-col>
              <el-col :span="24" v-if="checkedHasLogin" class="mt-3 mb-3">
                <el-row :gutter="20" type="flex" align="top" class="login-mode-section">
                  <!-- Login Mode Radio -->
                  <el-col :xs="24" :sm="12" :md="6" :span="4">
                    <div class="form-label">Select Login Mode</div>
                    <el-radio-group v-model="login_mode" size="mini">
                      <el-radio label="normal" border>Normal Login</el-radio>
                      <el-radio label="rbac" border>RBAC</el-radio>
                    </el-radio-group>
                  </el-col>

                  <!-- Entity Dropdown -->
                  <el-col :xs="24" :sm="12" :md="6" v-if="login_mode === 'rbac'">
                    <div class="form-label">Select Entities</div>
                    <el-select
                      v-model="roleEntities"
                      placeholder="Select Entities"
                      size="mini"
                      clearable
                      filterable
                      multiple
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(entity, index) in allEntitiesData.filter((e) =>
                          relationshipEntities.some((r) => r.child_entity_id === e._id)
                        )"
                        :key="entity._id + '_' + index"
                        :label="entity.name"
                        :value="entity._id"
                      />
                    </el-select>
                  </el-col>
                  <!-- Role Name + Level per entity -->
                  <template v-for="entityId in roleEntities">
                    <!-- Primary Field -->
                    <template>
                      <el-col :xs="24" :sm="12" :md="6" :key="entityId + '-name'">
                        <div class="form-label">
                          Select Primary Field in {{ getEntityName(entityId) }}
                        </div>
                        <el-select
                          v-model="roleConfig[entityId].roleName"
                          :placeholder="`Select ${getEntityName(entityId)} Name`"
                          size="mini"
                          clearable
                          filterable
                          style="width: 100%"
                        >
                          <el-option
                            v-for="field in getEntityFields(entityId)"
                            :key="field.template_key"
                            :label="field.label"
                            :value="field.template_key"
                          />
                        </el-select>
                      </el-col>
                    </template>

                    <!-- Level Field -->
                    <template>
                      <el-col :xs="24" :sm="12" :md="6" :key="entityId + '-level'">
                        <div class="form-label">
                          Select Level from {{ getEntityName(entityId) }}
                        </div>
                        <el-select
                          v-model="roleConfig[entityId].roleLevel"
                          :placeholder="`Select ${getEntityName(entityId)} Level`"
                          size="mini"
                          clearable
                          filterable
                          style="width: 100%"
                        >
                          <el-option
                            v-for="field in getEntityFields(entityId)"
                            :key="field.template_key"
                            :label="field.label"
                            :value="field.template_key"
                          />
                        </el-select>
                      </el-col>
                    </template>
                  </template>
                </el-row>
              </el-col>

              <el-col :span="12" v-if="checkedHasLogin">
                <div>
                  Application user alias
                  <el-input
                    v-model="receiverAlias"
                    placeholder="Enter alias"
                    size="mini"
                  ></el-input>
                </div>
              </el-col>
              <el-col :span="12" v-if="checkedHasLogin">
                <div>
                  Whom can login?
                  <el-select
                    placeholder="Select filter"
                    v-model="receiverFilter"
                    :filterable="true"
                    :clearable="true"
                    style="width: 100%"
                    size="mini"
                  >
                    <el-option
                      v-for="(filter, index) of entityFilters"
                      :key="index + '_filter'"
                      :label="filter.filter_name"
                      :value="filter._id"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="mt-1">
                  <el-checkbox v-model="isTabSwitchingAlert" placeholder="Enter alias" size="mini">
                    Enable Template Saving Alert.
                  </el-checkbox>
                </div>
                <div v-if="(currentEntityAllFields || []).some((doc) => doc.inputType === 'FILE')">
                  <div class="mt-1">
                    <el-checkbox v-model="downloadDocuments" size="mini">
                      Download Entity Documents
                    </el-checkbox>
                  </div>
                  <el-col v-if="downloadDocuments" class="mt-2">
                    <el-select
                      v-model="selectedDocuments"
                      placeholder="Select Documents"
                      multiple
                      size="mini"
                      collapse-tags
                    >
                      <el-option
                        v-for="doc in (currentEntityAllFields || []).filter(
                          (doc) => doc.inputType === 'FILE'
                        )"
                        :key="`${doc.template_id}#${doc.template_key}`"
                        :label="doc.label"
                        :value="doc.template_key"
                      />
                    </el-select>
                  </el-col>
                </div>
              </el-col>
            </el-row>
            <el-row class="mt-1" type="flex" justify="space-between" align="top">
              <el-col :span="12">
                <div>
                  Scheduling settings
                  <el-row>
                    <el-col>
                      <el-checkbox v-model="consider_as_scheduling">
                        Consider this as scheduling entity
                      </el-checkbox>
                    </el-col>
                    <el-col v-if="consider_as_scheduling">
                      <el-checkbox v-model="approval_mechanism">Is Approval?</el-checkbox>
                    </el-col>
                  </el-row>
                </div>
              </el-col>

              <el-col :span="12" v-if="entity_type == 'INDIVIDUAL'">
                <div>
                  Custom Alert Message
                  <el-row>
                    <el-col>
                      <el-checkbox v-model="enable_CustomizationMessage">
                        Enable Personalized Email Message
                      </el-checkbox>
                    </el-col>
                  </el-row>

                  <template v-if="enable_CustomizationMessage">
                    <el-row class="mt-2">
                      <el-col>
                        <el-select
                          v-model="emailCustomizationFields"
                          placeholder="Select Field"
                          clearable
                          filterable
                          @change="copyURL"
                        >
                          <el-option
                            v-for="element in allAvailableFields"
                            :key="element.key"
                            :label="element.label"
                            :value="element.key"
                          />
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row class="mt-2">
                      <el-col :span="18">
                        <el-input
                          type="textarea"
                          v-model="emailMessageText"
                          placeholder="Type your message and insert fields"
                          rows="3"
                        />
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </el-col>
            </el-row>

            <div class="mt-1">
              Activity Logs
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="enable_activity_logs">Enable Activity Logs</el-checkbox>
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="enable_bulkActions">Enable Bulk Actions</el-checkbox>
                </el-col>
              </el-row>
              <el-row>
                <el-col v-if="enable_activity_logs">
                  <el-checkbox v-model="require_delete_reason">
                    Require reason before delete
                  </el-checkbox>
                  <el-tooltip
                    class="ml-2"
                    effect="dark"
                    content="This ensures user to provide reason before deleting any record."
                    placement="top"
                  >
                    <i class="el-icon-info" style="margin-left: 5px"></i>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <div class="mt-1">
              Automation Settings
              <el-row>
                <el-col>
                  <el-checkbox v-model="perform_actions_without_approval">
                    Ensure actions are executed even when triggered via form builders or scheduling
                    component, subject to the approval mechanism.
                  </el-checkbox>
                  <el-tooltip
                    class="ml-2"
                    effect="dark"
                    content="Even when triggered automatically, data remains archived until approved. This ensures actions are performed even in archived state."
                    placement="top"
                  >
                    <i class="el-icon-info" style="margin-left: 5px"></i>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <br />
            <el-row>
              <el-col :span="24">
                <el-checkbox v-model="integrationConfig.isIntegrationConfig" @change="configChange">
                  Configure how inputs fetch data from third-party services.
                </el-checkbox>
                <el-tooltip
                  class="ml-2"
                  effect="dark"
                  content="Configure how inputs fetch data from third-party
                  services."
                >
                  <i class="el-icon-info" style="margin-left: 5px"></i>
                </el-tooltip>
              </el-col>
            </el-row>
            <span class="mt-1 content-spacing">
              <el-row v-if="integrationConfig.isIntegrationConfig" :gutter="30">
                <el-form>
                  <el-col :span="6">
                    <label>Select Application :</label>
                    <el-select
                      placeholder="Choose an application"
                      v-model="integrationConfig.application"
                      filterable
                      @change="handleChange"
                    >
                      <el-option
                        v-for="(option, index) in applications"
                        :key="index"
                        :label="option.label"
                        :value="option.key"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <label>Select Event :</label>
                    <el-select
                      placeholder="Choose an Event"
                      v-model="integrationConfig.event"
                      filterable
                    >
                      <el-option
                        v-for="(option, index) in events"
                        :key="index"
                        :label="option.eventName"
                        :value="option.eventKey"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <label>Select Integration :</label>
                    <el-select
                      placeholder="Choose an Integration"
                      v-model="integrationConfig.integration"
                      filterable
                    >
                      <el-option
                        v-for="(option, index) in allConnections"
                        :key="index"
                        :label="option.name"
                        :value="option._id"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      type="primary"
                      round
                      class="mt-2"
                      size="mini"
                      :disabled="enableConfig"
                      @click="openMappingConfig"
                    >
                      Map Fields
                    </el-button>
                  </el-col>
                </el-form>
              </el-row>
            </span>
            <div class="mt-1">
              App user view Settings
              <el-row>
                <el-button type="text" size="mini" @click="handleViewSettings">Configure</el-button>
                <el-tooltip
                  class="ml-2"
                  effect="dark"
                  content="These are the default settings for this entity. Your selected filters and customizations will be applied whenever you open the data from another source, like an email."
                  placement="top"
                >
                  <i class="el-icon-info" style="margin-left: 5px"></i>
                </el-tooltip>
                <el-drawer
                  title="View Settings"
                  :visible.sync="viewSettingsVisible"
                  direction="rtl"
                  :modal="false"
                  size="50%"
                  :before-close="validateBeforeClose"
                >
                  <div>
                    <!-- Table -->
                    <el-table :data="viewSettings" border style="width: 100%">
                      <el-table-column label="Entity" prop="entity" width="250">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.entity"
                            placeholder="Select Entity"
                            style="width: 100%"
                          >
                            <el-option
                              v-for="item in getIndividualEntities"
                              :key="item.value"
                              :label="item.name"
                              :value="item.value"
                              :disabled="isEntitySelected(item.value, scope.row)"
                            />
                          </el-select>
                        </template>
                      </el-table-column>

                      <el-table-column label="Filter" prop="filter">
                        <template slot-scope="scope">
                          <el-select
                            placeholder="Select filter"
                            v-model="scope.row.filter"
                            :filterable="true"
                            :clearable="true"
                            style="width: 100%"
                            size="mini"
                          >
                            <el-option
                              v-for="(filter, index) of entityFilters"
                              :key="index + '_filter'"
                              :label="filter.filter_name"
                              :value="filter._id"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>

                      <el-table-column label="Customization" prop="customization">
                        <template slot-scope="scope">
                          <el-select
                            placeholder="Select Customization"
                            v-model="scope.row.customization"
                            :filterable="true"
                            :clearable="true"
                            style="width: 100%"
                            size="mini"
                          >
                            <el-option
                              v-for="(item, index) of entityAllCustomizations"
                              :key="index + '_filter'"
                              :label="item.label"
                              :value="item._id"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>

                      <el-table-column label="Actions" width="120">
                        <template slot-scope="scope">
                          <el-button type="text" size="mini" @click="removeRow(scope.$index)">
                            Remove
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>

                    <!-- Add Button -->
                    <div class="mt-3" v-if="isAddRowVisible">
                      <el-button type="primary" size="mini" @click="addRow">+ Add Row</el-button>
                    </div>
                  </div>
                </el-drawer>
              </el-row>
            </div>
            <div class="mt-1">
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="whenActionSettings">Entity Action Settings</el-checkbox>
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="show_entity_hierarchy">
                    Entity Complete Data Hierarchy
                  </el-checkbox>
                </el-col>
              </el-row>
            </div>
            <div class="mt-1">
              <div class="mb-0.7 font-semibold">Entity Settings</div>
              <el-checkbox-group v-model="entity_settings">
                <el-checkbox label="layout-options">Layout Options</el-checkbox>
                <el-checkbox label="iframe-link">Iframe Link</el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-if="whenActionSettings">
              <label>Execute On :</label>
              <el-select
                v-model="whenOptions"
                multiple
                placeholder="Select When point"
                style="width: 100%"
              >
                <el-option
                  v-for="opt in executionOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
                <el-option
                  v-for="temp in currentEntityTemplates"
                  :key="temp._id"
                  :label="'Template-' + temp.name"
                  :value="'template/' + temp._id"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="cancelUpdate"
          size="mini"
          class="bg-transparent !px-3 !py-1 !rounded-md !text-xs 2xl:!text-sm !border !border-black-500 hover:border hover:!border-brand-500 hover:text-brand-500d !h-fit"
        >
          Cancel
        </el-button>
        <el-button
          size="mini"
          type="primary"
          @click="handleUpdate"
          :disabled="!entityName"
          style="background-color: var(--brand-500) !important"
          class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit !bg-brand-500 !text-brand-500 !border-brand-500"
        >
          Update
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :title="'Add New Group'"
      :visible="showAddGroupDialog"
      @before-close="showAddGroupDialog = false"
      :containerWidth="getIsMobile ? '100%' : '30%'"
      :isShowFooter="false"
    >
      <el-form
        class="m-tb-2"
        :model="entitiesListForm"
        ref="entitiesListForm"
        :rules="rules"
        @submit.native.prevent="saveGroup"
      >
        <el-form-item label="Group Title" prop="groupName">
          <el-input
            type="text"
            v-model="entitiesListForm.groupName"
            placeholder="Enter Title"
            :style="{ height: '50px' }"
          ></el-input>
        </el-form-item>

        <el-form-item class="float-right">
          <el-button
            class="btn btn-outline-danger btn-sm m-lr-1"
            type="button"
            @click="showAddGroupDialog = false"
            :disabled="loadingSaveGroup"
          >
            <i class="fa fa-close"></i>
            Cancel
          </el-button>

          <el-button
            class="btn btn-outline-primary btn-sm m-lr-1"
            type="primary"
            @click="saveGroup"
            :disabled="loadingSaveGroup || !entitiesListForm.groupName.trim()"
          >
            <i v-if="loadingSaveGroup" class="fa fa-spinner fa-spin"></i>
            <i v-else class="fa fa-check-square-o"></i>
            {{ loadingSaveGroup ? 'Saving...' : 'Save Group' }}
          </el-button>
        </el-form-item>
      </el-form>
    </dialog-component>
    <dialog-component
      :visible="goBackToEntities"
      :title="'Warning'"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      @before-close="goBackToEntities"
    >
      <div class="Back-in-Entity">
        <h5 class="fs-6">
          At least one template with primary field is required to project for the entity
          information.!
        </h5>
        <p class="fs-7 mt-1" style="margin-bottom: -33px">Are you sure to exit ?</p>
      </div>
      <span slot="footer">
        <el-button type="plain" @click="goBackToEntities = false" size="mini">No</el-button>
        <el-button type="primary" @click="backToEntities" size="mini">Yes</el-button>
      </span>
    </dialog-component>

    <el-dialog
      :visible.sync="showOrphanFieldsError"
      title="Warning"
      :width="getIsMobile ? '100%' : '50%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <ul>
          <li v-for="(el, index) of orphanFields" :key="index">
            {{ index + 1 }}. {{ el.related_reason }}
            <b>{{ el.field.label }}</b>
            , The Related fields are
            <b>{{ el.related_fields.map((e) => e.label).join(', ') }}</b>
          </li>
        </ul>
      </div>
      <span slot="footer">
        <el-divider></el-divider>
        <el-button type="primary" size="mini" @click="showOrphanFieldsError = false">Ok</el-button>
      </span>
    </el-dialog>
    <dialog-component
      :title="'Add Limit to ' + newRelationship.child_relation_title"
      :visible="limitPopup"
      :containerWidth="'27%'"
      @before-close="limitPopup = false"
      :isShowFooter="false"
    >
      <div class="mb-2 mt-4">
        <el-radio-group v-model="newRelationship.limit_type">
          <el-radio label="value">Value</el-radio>
          <el-radio label="field">Field</el-radio>
        </el-radio-group>
        <br />
        <br />
        <el-input-number
          placeholder="Enter limit"
          v-if="newRelationship.limit_type == 'value'"
          style="width: 100%"
          v-model="newRelationship.limit_value"
        ></el-input-number>
        <el-select
          placeholder="Select a Number Field"
          v-if="newRelationship.limit_type == 'field'"
          v-model="newRelationship.limit_field"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="(num, index) in parentEntityNumberFields"
            :key="index"
            :value="num.template_key"
            :label="num.label"
          ></el-option>
        </el-select>
        <p style="margin-top: 20px; margin-bottom: 5px">Warning message</p>
        <el-input
          v-model="newRelationship.warning_message"
          placeholder="Enter warning message"
        ></el-input>
      </div>
      <span>
        <el-button
          class="mb-1 !text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit !bg-brand-500 !border-brand-500"
          type="primary"
          style="float: right"
          size="mini"
          @click="addRelationship(editIndex)"
          :disabled="disableAddLimit()"
        >
          Add Limit
        </el-button>
        <el-button
          style="float: right; margin-right: 10px"
          size="mini"
          class="bg-transparent !px-3 !py-1.5 !rounded-md !text-xs 2xl:!text-sm !border !border-black-500 hover:border hover:!border-brand-500 hover:!text-brand-500 !h-fit"
          @click="addRelationship(editIndex, true)"
        >
          Skip
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      title="Map Fields"
      :visible="enableMapping"
      :isShowFooter="true"
      :containerWidth="'40%'"
      :containerHeight="'55%'"
      @before-close="closeMappingConfig"
    >
      <ExternalSourceMapping
        :params="integrationConfig"
        :sourceFields="sourceFields"
        :targetFields="targetFields"
        :applications="applications"
        :mappingConfigLoading="mappingConfigLoading"
      ></ExternalSourceMapping>
      <span slot="footer" class="dialog-footer">
        <el-button type="plain" @click="closeMappingConfig">
          <span>Cancel</span>
        </el-button>
        <el-button type="primary" @click="validateAndSave">
          <i class="el-icon-finished"></i>
          <span>Save</span>
        </el-button>
      </span>
    </dialog-component>
  </section>
</template>
<script>
  import { bus } from '../../main';
  import { mapGetters } from 'vuex';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  import CompanyDocumentsHelper from '@/mixins/CompanyDocumentsHelper';
  import NavigationHelper from '@/mixins/navigationHelper';
  import EntityHelper from '@/mixins/EntitiesHelper';
  import AutomationHelper from '@/mixins/AutomationHelper';

  import { getAllCompanyTemplatesByPagination } from '@/repo/templatesRepo';
  import {
    updateEntityData,
    fetchEntitiesByPagination,
    addSingleEntityToLocal,
  } from '@/repo/entityRepo';
  import { fetchActiveEntityCustomizationsByEntity } from '@/repo/entityCustomizationRepo';
  import { fetchGroups, addSingleGroupToLocal } from '@/repo/groupsRepo';
  import { postAPICall } from '../../helpers/httpHelper';
  import { fetchEntityRelationships } from '@/repo/entityRelationshipsRepo';
  import appConfig from '../../config/app';
  import { fetchEntityById } from '../../repo/entityRepo';
  import { getAllFieldsArrayFromEntity } from '../../utils/formatter';
  import { createIcons, getIconKeysFromMasterIcons } from '@/repo/iconsRepo';
  import axios from '@/config/axios';
  export default {
    name: 'Entity-AddEditEntity',
    components: {
      DropTemplates: () => import('./DropTemplates'),
      draggable: () => import('vuedraggable'),
      EntityActions: () => import('./EntityActions'),
      EntityCustomizations: () => import('./EntityCustomizations'),
      CustomEntityMention: () => import('@/components/widgets/entityMention/index.vue'),
      ExternalSourceMapping: () => import('./ExternalSourceMapping.vue'),
    },
    mixins: [
      AutomationHelper,
      MobileRelatedHelper,
      CompanyDocumentsHelper,
      NavigationHelper,
      EntityHelper,
    ],
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      if (this.getIsMobile) {
        this.$store.commit('navigationOpen/setIsOpen', false, {
          root: true,
        });
        this.$store.commit('navigationOpen/setIsRSOpen', false, {
          root: true,
        });
      }
      bus.$on('tabsConfigStatus', (status) => {
        this.hasUnsavedChanges = status;
      });
    },

    data() {
      return {
        whenOptions: [],
        executionOptions: [
          { value: 'ADDED', label: 'Added' },
          { value: 'NOTIFICATION', label: 'Notification' },
          { value: 'DELETED', label: 'Deleted' },
          { value: 'TRANSACTION', label: 'Record Payment' },
          { value: 'AUTOMATION', label: 'Recurring' },
          { value: 'FILE_ADDED', label: 'File added' },
          { value: 'DATE_TIME', label: 'Date/Time Field' },
        ],
        sourceFields: [],
        targetFields: [],
        allConnections: [],
        applications: [],
        events: [],
        enableMapping: false,
        integrationConfig: {
          isIntegrationConfig: false,
          application: '',
          event: '',
          integration: '',
          mappingConfig: {},
        },
        mappingConfigLoading: false,
        emailMessageText: '',
        consider_as_scheduling: false,
        entityAllCustomizations: [],
        viewSettingsVisible: false,
        viewSettings: [{ entity: '', filter: '', customization: '' }],
        entityOptions: [
          { value: 'entity1', label: 'Entity 1' },
          { value: 'entity2', label: 'Entity 2' },
          { value: 'entity3', label: 'Entity 3' },
        ],
        perform_actions_without_approval: false,
        require_delete_reason: false,
        enable_activity_logs: false,
        enable_bulkActions: true,
        enable_CustomizationMessage: false,
        emailCustomizationFields: '',
        whenActionSettings: false,
        show_entity_hierarchy: true,
        approval_mechanism: false,
        isTabSwitchingAlert: '',
        getEntityRecordsForTable: null,
        downloadDocuments: '',
        selectedDocuments: [],
        entitiesListForm: {
          groupName: '',
        },
        rules: {
          groupName: [
            {
              required: true,
              message: 'Please input the group name',
              trigger: 'blur',
            },
          ],
        },
        selectedFieldId: '',
        hasUnsavedChanges: false,
        isValidSelection: true,
        activeStep: -1,
        loading: false,
        loadingText: 'Loading...',
        entityName: '',
        originalEntityName: '',
        description: '',
        printingDocuments: [],
        defaultPrintingDocument: '',
        exportPrintingDocument: '',
        originalEntityData: {},
        allDocumentTemplates: [],
        modalLoading: false,
        goBackToEntities: false,
        isEdit: false,
        allTemplates: [],
        selectedEntity: [],
        isUpdate: false,
        primaryFields: [],
        editable: true,
        isDragging: false,
        delayedDragging: false,
        allFields: [],
        newEntityModal: false,
        isAccount: false,
        isSaveAsDraft: false,
        isRestrictMultiple: false,
        lockDurationValue: 5,
        lockDurationUnit: 'HOURS',
        entity_type: 'GENERAL',
        allEntitytemplateData: [],
        isSubmit: false,
        isSave: false,
        showAddGroupDialog: false,
        loadingSaveGroup: false,
        entityGroupsData: [],
        entity_settings: ['layout-options', 'iframe-link'],
        allEntities: [],
        otherEntities: [],
        relationshipsData: [],
        entityId: [],
        allEmailTemplates: [],
        defaultEmailTemplate: '',
        defaultParentTemplate: '',
        newRelationship: {
          parent_entity_id: '',
          child_entity_id: '',
          child_relation_title: '',
          child_relation_type: 'MANY',
          parent_relation_title: '',
          parent_relation_type: 'ONE',
          is_bidirectional: true,
          representation: 'TAB',
          limit_type: 'value',
          limit_value: null,
          limit_field: '',
          warning_message: 'You have reached the limit !',
        },
        newRelationshipsData: [],
        orphanFields: [],
        showOrphanFieldsError: false,
        checkedHasLogin: true,
        checked_newuser: false,
        receiverAlias: '',
        receiverFilter: '',
        hasData: false,
        currentEntity: null,
        saveClicked: false,
        limitPopup: false,
        editIndex: -1,
        parentEntityNumberFields: [],
        entityFilters: [],
        standardTemplate: null,
        getAllEntityGroupsData: [],
        tempEntity: null,
        firstTemplateId: '',
        qrCodeImportField: '',
        qrCodeImportField_search_type: 'Record Id',
        qrCodeImportField_search_field: '',
        qrCodeImportField_custom_message: 'Data has been added!',
        qrCodeImportField_error_message: 'Error while adding data!',
        qrCodeImportField_success_title: 'Added!',
        qrCodeImportField_error_title: 'Failed!',
        currentEntityAllFields: null,
        copyField: '',
        allEntityFields: [],
        docLoading: false,
        customization: {},
        previousTemplates: [],
        fetchedRelationships: null,
        pdfData: {
          custom_message: '',
        },
        login_mode: null,
        allEntitiesData: [],
        relationshipEntities: [],
        selectedEntityFields: [],
        is_mfa: false,
        roleEntities: [],
        roleConfig: {},
        entityFieldsMap: {},
      };
    },
    computed: {
      currentEntityTemplates() {
        return (this.currentEntity.templates || []).flatMap((e) => e.templateInfo);
      },
      enableConfig() {
        if (
          this.integrationConfig.application &&
          this.integrationConfig.event &&
          this.integrationConfig.integration
        ) {
          return false;
        } else {
          return true;
        }
      },
      allAvailableFields() {
        const all = [...this.draggableFields];

        this.primaryFields.forEach((pf) => {
          if (!all.find((f) => f.key === pf.key)) {
            all.push(pf);
          }
        });
        return all;
      },
      getIndividualEntities() {
        console.log('allEntitiesData', this.allEntitiesData);
        return (
          (this.allEntitiesData.filter((e) => e.entity_type == 'INDIVIDUAL') || []).map((e) => {
            return {
              name: e.name,
              value: e._id,
            };
          }) || []
        );
      },
      isAddRowVisible() {
        return this.getIndividualEntities.length > this.viewSettings.length;
      },
      getCustomMsgData() {
        let pdfDataCopy = { ...this.pdfData };
        if (!pdfDataCopy?.custom_message) {
          pdfDataCopy.custom_message = this.currentEntity?.name ? this.currentEntity.name : '';
        }
        return pdfDataCopy;
      },
      dragOptions() {
        return {
          animation: 0,
          group: 'description',
          disabled: !this.editable,
          ghostClass: 'ghost',
        };
      },
      draggableFields() {
        return this.allFields.filter((field) => field.type !== 'CONTENT');
      },
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile', 'getIsRSOpen']),
      ...mapGetters('entities', [
        'getEntityCreatedStatus',
        'getEntityCreatedData',

        'getEntityDataById',
        'getEntityDataUpdateStatus',
        'getEntityErrors',
      ]),
      ...mapGetters('auth', ['getAuthenticatedUser']),
      ...mapGetters('templatesData', ['getTemplateDataByentityId']),
      ...mapGetters('entityCustomization', ['getAllCustomizations']),
      ...mapGetters('entityGroups', [
        'getSingleEntityGroupData',
        'getEntityGroupErrors',
        'getError',
      ]),

      ...mapGetters('entityRelationships', [
        'getEntityRelationshipAddStatus',
        'getEntityRelationships',
        'getEntityRelationshipUpdateStatus',
        'getEntityRelationshipDeleteStatus',
      ]),

      ...mapGetters('errors', ['getError', 'getErrors']),
      ...mapGetters('documents', ['getAllTemplates']),
      ...mapGetters('filters', ['getAllEntityFilters']),
      ...mapGetters('sso', ['getAuthenticatedSSOToken', 'getIsUserLoggedIn']),
      ...mapGetters('iFrame', ['getIframeUrlInfo']),
      ...mapGetters('auth', ['getActiveWorkspace']),
      getLoginUrl() {
        return this.getEntityDataById?.entity_code
          ? `${appConfig.APP_URL}/${this.getEntityDataById?.entity_code}`
          : '';
      },
      getLoginDescription() {
        return `For Tenant registration, use ${this.getEntityDataById?.entity_code} in the mobile app, or visit ${this.getLoginUrl} to register via web.`;
      },
      selectedEntityName() {
        const entity = this.allEntitiesData.find((e) => e._id === this.roleEntity);
        return entity ? entity.name : 'Role';
      },
    },
    async mounted() {
      this.checkIsEdit();
      await Promise.all([
        this.fetchTemplates(),
        this.fetchEntityId(),
        this.fetchEntityData(),
        this.fetchAllCompanyTemplates(),
        this.getEntityCustomizations(),
        this.fetchCompanyGroups(),
        this.fetchEmailTemplates(),
        this.fetchActiveCustomization(),
        this.fetchEntities(),
      ]);
      let [allFields] = await Promise.all([
        this.fetchEntityDetails(this.getEntityDataById?._id, true, true),
        this.fecthEntityData(),
      ]);
      this.currentEntityAllFields = allFields;
      this.fetchRelationalEntities();
    },
    methods: {
      copyLoginURL() {
        const textToCopy = this.getLoginUrl;
        if (!textToCopy) return;
        navigator.clipboard.writeText(textToCopy);
        this.$message({
          message: 'Link copied successfully!',
          type: 'success',
        });
      },
      getEntityName(entityId) {
        const entity = this.allEntitiesData.find((e) => e._id === entityId);
        return entity ? entity.name : '';
      },
      getEntityFields(entityId) {
        return this.entityFieldsMap[entityId] || [];
      },
      async configChange() {
        if (this.integrationConfig.isIntegrationConfig) {
          await this.getAllSources();
        }
      },
      async handleChange(value) {
        let application = this.applications.find((app) => app.key === value);
        this.events = application.events;
        await this.loadIntegrations();
      },
      closeMappingConfig() {
        this.enableMapping = false;
      },
      validateAndSave() {
        const missingFields = this.sourceFields.filter(
          (field) =>
            field.required && !this.integrationConfig.mappingConfig[field.applicationFieldKey]
        );
        if (missingFields.length > 0) {
          this.$message.error('Please map all required fields.');
          return;
        }
        this.enableMapping = false;
      },
      async openMappingConfig() {
        try {
          let event = this.events.find((event) => event.eventKey === this.integrationConfig.event);
          this.enableMapping = true;
          let fields;
          let validRequest = false;
          let settings = event.settings;
          if (settings.dynamicResponseFields) {
            if (
              settings.fieldsRequiredToloadResponseFields &&
              settings.fieldsRequiredToloadResponseFields.length
            ) {
              validRequest = settings.fieldsRequiredToloadResponseFields.every((field) => {
                return this.externalSourceConfiguration.form[field];
              });
            } else {
              validRequest = true;
            }
            if (validRequest) {
              this.mappingConfigLoading = true;
              const result = await postAPICall(
                'POST',
                'integrations/service/getRequiredFields',
                this.externalSourceConfiguration
              );
              this.mappingConfigLoading = false;
              fields = result.data;
            }
          } else {
            fields = event.settings.availableColumns;
          }
          let entityFields = this.getAllFieldsFromEntity(this.currentEntity, false, false, true);
          this.sourceFields = entityFields.map((field) => {
            return {
              applicationFieldLabel: field.label,
              applicationFieldKey: field.key,
              required: field.validations.required,
            };
          });
          this.targetFields = fields;
        } catch (err) {
          this.mappingConfigLoading = false;
        }
      },
      async getAllSources() {
        let applicationsList = await postAPICall(
          'GET',
          'integrations/service/get-all-applications'
        );
        this.applications = applicationsList.data;
      },
      async loadIntegrations() {
        let params = {
          limit: 10,
          page: 1,
        };
        const result = await postAPICall('GET', 'integrations', params);
        this.allConnections = result.data;
      },
      async fetchEntities() {
        try {
          let response = await axios.get('/entities/fetchAllEntities');
          if (response?.data) {
            this.allEntitiesData = response.data.data || [];
          }
        } catch (err) {
          return [];
        }
      },
      handleViewSettings() {
        if (!this.viewSettings?.length) {
          this.viewSettings = [{ entity: '', filter: '', customization: '' }];
        }
        this.viewSettingsVisible = true;
      },
      addRow() {
        this.viewSettings.push({ entity: '', filter: '', customization: '' });
      },
      removeRow(index) {
        this.viewSettings.splice(index, 1);
      },
      isEntitySelected(value, currentRow) {
        // Prevent duplicate entity selection except for current row
        return this.viewSettings.some((row) => row !== currentRow && row.entity === value);
      },
      async getEntityCustomizations() {
        await this.$store.dispatch(
          'entityCustomization/fetchAllEntityCustomizations',
          this.$route.params.entity_id
        );
        this.entityAllCustomizations = [];
        if (this.getAllCustomizations) {
          this.entityAllCustomizations = this.getAllCustomizations.data;
        }
      },
      validateBeforeClose(done) {
        let hasError = false;

        // Filter out rows where entity is not selected
        this.viewSettings = this.viewSettings.filter((row) => {
          if (!row.entity) {
            return false;
          }
          if (!row.filter && !row.customization) {
            this.$message.warning(
              'Please select at least filter or customization for all chosen entities.'
            );
            hasError = true;
          }
          return true;
        });

        if (!hasError) {
          done();
        }
      },
      async fetchRelationalEntities() {
        try {
          let response = await axios.get(
            `/entities/${this.$route.params.entity_id}/relationships`,
            {
              entity_id: this.$route.params.entity_id,
            }
          );
          this.relationshipEntities = response.data.data || [];
        } catch (err) {
          return [];
        }
      },
      async fetchFieldsByEntity(entityId) {
        this.selectedEntityFields = await this.fetchEntityDetails(entityId, true, true);
        this.$set(this.entityFieldsMap, entityId, this.selectedEntityFields);
        return;
      },
      handleUpdate() {
        if (
          this.downloadDocuments &&
          (!this.selectedDocuments || this.selectedDocuments.length === 0)
        ) {
          this.$message.error('Please select the documents to download.');
          return;
        }
        this.newEntityModal = false;
      },
      async fetchActiveCustomization() {
        let response = await fetchActiveEntityCustomizationsByEntity(this.$route.params.entity_id);
        if (response) {
          this.customization = { ...response };
          this.loadIconsFromCustomization();
        }
      },
      async loadIconsFromCustomization() {
        const companyId = this.getActiveWorkspace.company_id;
        const key = `${companyId}:customization`;
        const icons = [];
        try {
          const customization = this.customization;
          if (Array.isArray(customization.actions)) {
            customization.actions.forEach((action) => {
              if (action.icon) {
                icons.push(action.icon);
              }
            });
          }
          if (Array.isArray(customization.tab_groups)) {
            customization.tab_groups.forEach((group) => {
              if (Array.isArray(group.tabs)) {
                group.tabs.forEach((tab) => {
                  if (tab.icon) {
                    icons.push(tab.icon);
                  }
                });
              }
            });
          }
          const iconKeys = await getIconKeysFromMasterIcons(icons);
          await createIcons(key, iconKeys);
        } catch (error) {
          console.error('Error loading icons from customization:', error);
        }
      },
      checkSelection() {
        this.isValidSelection = this.entityGroupsData.length > 0;
      },
      getEmailTemplates(type) {
        return this.allEmailTemplates.filter((temp) => temp.type == type);
      },
      getValidFields() {
        return [
          ...(this.currentEntityAllFields || []).filter(
            (fd) => fd.type != 'CONTENT' && !['DATA_TABLE', 'ENTITY_TABLE'].includes(fd.inputType)
          ),
        ];
      },
      pushToErrorMessage(field, type) {
        if (type == 'success') {
          this.qrCodeImportField_custom_message =
            this.qrCodeImportField_custom_message + ` [[${field}]]`;
        } else {
          this.qrCodeImportField_error_message =
            this.qrCodeImportField_error_message + ` [[${field}]]`;
        }
        this.$message({
          message: `${field} added to the message`,
          type: 'success',
        });
      },
      copyURL(field) {
        navigator.clipboard.writeText(`[[${field}]]`);
        this.$message({
          message: 'Field Copied!',
          type: 'success',
        });
      },
      checkIndividualEntity(v1) {
        if (v1 == 'INDIVIDUAL') {
          let checkIndividualEntity = this.selectedEntity.find(
            (t) => t?.template_id == this.standardTemplate._id
          );
          if (!checkIndividualEntity) {
            this.selectedEntity.unshift({
              is_repeatable: false,
              is_public: true,
              max_records: 1,
              isActive: true,
              default_display: 'TABLE',
              template_order: 1,
              receiverAlias: '',
              senderAlias: '',
              template_id: this.standardTemplate._id,
              templateInfo: this.standardTemplate,
              downloadDocuments: '',
              selectedDocuments: [],
            });
          }
        } else {
          let checkIndividualEntity = this.selectedEntity.findIndex(
            (t) => t?.template_id == this.standardTemplate._id
          );
          if (checkIndividualEntity > -1) {
            this.selectedEntity.splice(checkIndividualEntity, 1);
          }
        }
      },
      async openNewEntityModal() {
        if (this.$route?.params?.entity_id) {
          await this.getEntityFilters(this.$route.params.entity_id);
        }
        if (!this.receiverAlias) {
          this.receiverAlias = this.entityName;
        }
        this.originalEntityName = this.entityName;
        this.originalEntityData = {
          description: this.description,
          printingDocuments: JSON.parse(JSON.stringify(this.printingDocuments)),
          defaultPrintingDocument: this.defaultPrintingDocument,
          exportPrintingDocument: this.exportPrintingDocument,
          defaultEmailTemplate: this.defaultEmailTemplate,
          defaultParentTemplate: this.defaultParentTemplate,
          entityGroupsData: JSON.parse(JSON.stringify(this.entityGroupsData)),
        };
        this.newEntityModal = true;
        this.allEntityFields = await this.fetchEntityDetails(
          this.$route.params.entity_id,
          false,
          false,
          false,
          true,
          true,
          true
        );
        if (!this.allEntityFields?.length) {
          this.updateEntity();
        }
      },
      async cancelUpdate() {
        if (this.$route?.params?.entity_id) {
          await this.getEntityFilters(this.$route.params.entity_id);
        }
        if (!this.receiverAlias) {
          this.receiverAlias = this.entityName;
        }
        this.entityName = this.originalEntityName;
        this.description = this.originalEntityData.description;
        this.printingDocuments = JSON.parse(
          JSON.stringify(this.originalEntityData.printingDocuments)
        );
        this.defaultPrintingDocument = this.originalEntityData.defaultPrintingDocument;
        this.exportPrintingDocument = this.originalEntityData.exportPrintingDocument;
        this.defaultEmailTemplate = this.originalEntityData.defaultEmailTemplate;
        this.defaultParentTemplate = this.originalEntityData.defaultParentTemplate;
        this.entityGroupsData = JSON.parse(
          JSON.stringify(this.originalEntityData.entityGroupsData)
        );
        this.newEntityModal = false;
      },
      async getEntityFilters(entity_id) {
        await this.$store.dispatch('filters/fetchAllEntityFilters', {
          entityId: entity_id,
        });
        this.entityFilters = [];
        if (this.getAllEntityFilters) {
          this.entityFilters = this.getAllEntityFilters;
        }
      },
      async fetchAllCompanyTemplates() {
        await this.$store.dispatch('documents/fetchAllTemplates', {
          get_all: true,
        });
        this.allDocumentTemplates =
          this.getAllTemplates && this.getAllTemplates.data ? this.getAllTemplates.data : [];
      },
      async fetchEmailTemplates() {
        let params = {
          page: 1,
          limit: 40,
          entity_id: this.$route.params.entity_id,
          getAll: true,
          include_parent: true,
        };
        let response = await postAPICall('GET', 'email-template/list', params);
        this.allEmailTemplates = response.data;
      },
      async fetchEntityData() {
        let currentEntity = await fetchEntityById(this.$route.params.entity_id);
        let params = {
          entity_id: this.$route.params.entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(currentEntity),
          format_data: true,
          filters: [],
          relationship: this.realtionshipFilter,
          limit: 1,
          page: 1,
        };

        const v2Response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
        this.getEntityRecordsForTable = v2Response?.data;
        if (this.getEntityRecordsForTable?.data && this.getEntityRecordsForTable.data.length) {
          this.hasData = true;
        }
      },
      updatedPrimaryFields(key) {
        this.primaryFields = this.primaryFields.map((e) => {
          if (key != e.key) {
            e.is_primary = false;
          }

          return e;
        });
        this.allFields = this.allFields.filter((field) => field.key !== key);
      },
      async backToEntities() {
        let query = this.getNavigationQuery(this.$route.query);
        let UrlPath = '';
        UrlPath = '/entity/';
        this.$router.push({
          path: UrlPath,
          query: query,
        });
        this.goBackToEntities = false;
      },
      /*  ***Fetch Groups  start  **** */
      async fetchCompanyGroups() {
        try {
          const groups = await fetchGroups({
            get_all: true,
          });
          if (groups?.data) {
            this.getAllEntityGroupsData = [...groups.data];
          }
        } catch (e) {
          console.log('fetchCompanyGroups', e);
        }
      },
      /*  ***Fetch Groups  end  **** */
      async addGroupPopUP() {
        this.showAddGroupDialog = true;

        await this.$store.dispatch('entityGroups/resetErrors');
      },
      async saveGroup() {
        this.loadingSaveGroup = true;
        await this.$store.dispatch('entityGroups/addEntityGroup', {
          name: this.entitiesListForm.groupName,
          description: '',
          entities: [],
        });
        if (this.getSingleEntityGroupData && this.getSingleEntityGroupData.success) {
          await addSingleGroupToLocal(this.getSingleEntityGroupData.data);
          this.fetchCompanyGroups();
          this.loadingSaveGroup = false;
          this.entitiesListForm.groupName = '';
          this.showAddGroupDialog = false;
          this.entityGroupsData.push(this.getSingleEntityGroupData.data._id);
        } else if (this.getError && !this.getError.success) {
          this.loadingSaveGroup = false;
          let msg =
            this.getError && this.getError.message ? this.getError.message : 'Something went wrong';
          this.$message.warning(msg);
        }
      },

      updateEntityTemplates(templates) {
        if (templates) {
          this.selectedEntity = templates;
          if (this.isSave) {
            this.createEntity();
          } else if (this.isUpdate) {
            this.updateEntity();
          }
        }
      },
      destroyCreateModal() {
        this.cancelUpdate();
        this.newEntityModal = false;
      },

      checkEntitiesParentTitle(id) {
        let entity = this.otherEntities.find((x) => x._id == id);
        let currentEntity = this.entityName;

        if (entity.name && !this.newRelationship.child_relation_title) {
          this.newRelationship.child_relation_title = entity.name;
        }
        if (currentEntity && !this.newRelationship.parent_relation_title) {
          this.newRelationship.parent_relation_title = currentEntity;
        }
      },

      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        if (draggedElement.type === 'CONTENT') {
          return false;
        }
        return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
      },
      gotoBuilder() {
        this.activeStep = 0;
      },
      checkIsEdit() {
        if (this.$route && this.$route.name && this.$route.name == 'Edit Entity') {
          this.isEdit = true;
          this.entityId = this.$route.params.entity_id;
        } else {
          if (this.$route && this.$route.query && this.$route.query.name) {
            this.entityName = this.$route.query.name;
          }
        }
      },

      async updateEntity(close = false) {
        this.loading = true;
        if (this.entityName) {
          if (this.selectedEntity && this.selectedEntity.length) {
            if (this.activeStep === 1) {
              if (!this.primaryFields.length) {
                this.$message.warning(
                  'At least one Primary Field is required to project for the entity information'
                );
                this.loading = false;
              } else {
                this.update(close);
              }
            } else {
              this.update(close);
            }
          } else {
            this.isSubmit = false;
            this.$message.warning('Please add at least one template');

            this.loading = false;
          }
        } else {
          this.isSubmit = false;
          this.$message.warning('Entity name required');
          this.loading = false;
        }
      },
      async updateLocalEntityData(id, params) {
        let currentEntity = JSON.parse(JSON.stringify({ ...this.tempEntity, ...params }));
        this.tempEntity = {
          ...currentEntity,
          ...{
            templates: currentEntity.templates.map((t) => {
              if (t?.templateInfo) {
                delete t.templateInfo;
              }
              return t;
            }),
          },
        };
        updateEntityData(id, this.tempEntity);
      },
      async fetchEntityId(setTab = 0) {
        this.modalLoading = true;
        let id = this.$route.params.entity_id;
        this.currentEntity = null;
        await this.$store.dispatch('entities/fetchEntityById', { entity_id: id });
        if (this.getEntityDataById) {
          this.firstTemplateId = this.getEntityDataById.templates[0]?.template_id;
          this.currentEntity = this.getEntityDataById;
          this.entityName = this.getEntityDataById.name;
          this.description = this.getEntityDataById.description;
          this.primaryFields = this.getEntityDataById.primaryFields;
          this.isAccount = this.getEntityDataById.isAccount;
          this.isSaveAsDraft = this.getEntityDataById?.isSaveAsDraft;
          this.isRestrictMultiple = this.getEntityDataById?.isRestrictMultiple;
          this.lockDurationValue = this.getEntityDataById?.lockDurationValue || 5;
          this.lockDurationUnit = this.getEntityDataById?.lockDurationUnit || 'HOURS';
          this.entity_type = this.getEntityDataById.entity_type;
          this.entityGroupsData = this.getEntityDataById.entity_groups;
          this.checkedHasLogin = this.getEntityDataById.has_login;
          this.isTabSwitchingAlert = this.getEntityDataById.is_tab_switching_alert;
          this.downloadDocuments = this.getEntityDataById.isDownloadDocuments;
          this.selectedDocuments = this.getEntityDataById.isSelectedDocuments;
          this.receiverAlias = this.getEntityDataById.receiver_alias;
          this.receiverFilter = this.getEntityDataById.receiver_filter;
          this.printingDocuments = this.getEntityDataById.printing_documents;
          this.defaultEmailTemplate = this.getEntityDataById.default_email_template;
          this.defaultParentTemplate = this.getEntityDataById.default_parent_template;
          this.qrCodeImportField = this.getEntityDataById.qr_code_import_field;
          this.qrCodeImportField_search_type = this.getEntityDataById.qrCodeImportField_search_type;
          this.qrCodeImportField_search_field =
            this.getEntityDataById.qrCodeImportField_search_field;
          this.qrCodeImportField_custom_message =
            this.getEntityDataById.qrCodeImportField_custom_message || 'Data has been added!';
          this.qrCodeImportField_error_message =
            this.getEntityDataById.qrCodeImportField_error_message || 'Error adding data!';
          this.qrCodeImportField_success_title =
            this.getEntityDataById.qrCodeImportField_success_title || 'Added';
          this.qrCodeImportField_error_title =
            this.getEntityDataById.qrCodeImportField_error_title || 'Failed';
          this.defaultPrintingDocument = this.getEntityDataById.default_printing_document;
          this.exportPrintingDocument = this.getEntityDataById.export_printing_document;
          this.pdfData = this.getEntityDataById.pdf_printing_info;
          this.consider_as_scheduling = this.getEntityDataById.consider_as_scheduling;
          this.perform_actions_without_approval =
            this.getEntityDataById.perform_actions_without_approval;
          this.require_delete_reason = this.getEntityDataById.require_delete_reason;
          this.enable_activity_logs = this.getEntityDataById.enable_activity_logs;
          this.entity_settings = this.getEntityDataById?.entity_settings || this.entity_settings;
          this.viewSettings = this.getEntityDataById.view_settings;
          if (!this.viewSettings) {
            this.viewSettings = [{ entity: '', filter: '', customization: '' }];
          }
          this.enable_bulkActions =
            this.getEntityDataById.enable_bulkActions !== undefined
              ? this.getEntityDataById.enable_bulkActions
              : true;
          this.enable_CustomizationMessage = this.getEntityDataById.enable_CustomizationMessage;
          this.whenActionSettings = this.getEntityDataById.whenActionSettings;
          this.show_entity_hierarchy =
            this.getEntityDataById.show_entity_hierarchy !== undefined
              ? this.getEntityDataById.show_entity_hierarchy
              : true;
          this.emailCustomizationFields = this.getEntityDataById.emailCustomizationFields;
          this.whenOptions = this.getEntityDataById.whenOptions;
          this.emailMessageText = this.getEntityDataById.emailMessageText;
          this.approval_mechanism = this.getEntityDataById.approval_mechanism;
          this.login_mode = this.getEntityDataById?.login_mode;
          let roleDetails = [];
          if (Array.isArray(this.getEntityDataById?.role_details)) {
            roleDetails = this.getEntityDataById.role_details;
          } else if (
            this.getEntityDataById?.role_details &&
            typeof this.getEntityDataById.role_details === 'object'
          ) {
            roleDetails = [this.getEntityDataById.role_details];
          }
          if (this.login_mode === 'rbac' && roleDetails.length) {
            this.roleEntities = roleDetails.map((item) => item.roleEntity);
            roleDetails.forEach((item) => {
              this.$set(this.roleConfig, item.roleEntity, {
                roleName: item.roleName,
                roleLevel: item.roleLevel,
              });
              this.fetchFieldsByEntity(item.roleEntity);
            });
          }
          this.setSelectedTemplates(setTab);
          this.updateLocalEntityData(id, this.getEntityDataById);
          this.checked_newuser = this.getEntityDataById.checked_newuser;
          this.is_mfa = this.getEntityDataById.is_mfa;
          this.integrationConfig = this.getEntityDataById.external_config || {
            isIntegrationConfig: false,
            application: '',
            event: '',
            integration: '',
            mappingConfig: {},
          };
          if (this.integrationConfig?.application) {
            await Promise.all([this.getAllSources(), this.loadIntegrations()]);
            let application = this.applications.find(
              (app) => app.key === this.integrationConfig['application']
            );
            this.events = application.events;
          }
        } else {
          this.modalLoading = false;
        }
      },
      setSelectedTemplates(setTab) {
        let order_temp = (this.getEntityDataById?.templates || []).sort(
          (a, b) => a.template_order - b.template_order
        );
        this.activeStep = setTab;
        if (this.allTemplates) {
          this.previousTemplates = JSON.parse(JSON.stringify(order_temp));
          this.selectedEntity = order_temp;
        }
        this.modalLoading = false;
      },
      prepareParams() {
        let temp_order = this.selectedEntity.map((temp, index) => {
          temp.template_order = index + 1;
          return temp;
        });
        this.primaryFields = this.primaryFields.map((e, i) => {
          e.order = i;
          return e;
        });
        if (this.getCustomMsgData?.custom_message) {
          this.getCustomMsgData.custom_message = this.getCustomMessageWithIds(
            this.getCustomMsgData.custom_message
          );
        }

        this.checkRelationFields();

        return {
          name: this.entityName.trim(),
          description: this.description,
          entity_type: this.entity_type,
          templates: temp_order,
          id: this.$route.params.entity_id,
          primaryFields: this.primaryFields,
          entity_groups: this.entityGroupsData,
          has_login: this.checkedHasLogin,
          checked_newuser: this.checked_newuser,
          is_tab_switching_alert: this.isTabSwitchingAlert,
          isDownloadDocuments: this.downloadDocuments,
          isSelectedDocuments: this.selectedDocuments,
          receiver_alias: this.receiverAlias,
          receiver_filter: this.receiverFilter,
          isAccount: this.isAccount,
          isSaveAsDraft: this.isSaveAsDraft,
          isRestrictMultiple: this.isRestrictMultiple,
          lockDurationValue: this.lockDurationValue,
          lockDurationUnit: this.lockDurationUnit,
          printing_documents: this.printingDocuments,
          pdf_printing_info: this.getCustomMsgData,
          default_printing_document: this.defaultPrintingDocument,
          export_printing_document: this.exportPrintingDocument,
          default_email_template: this.defaultEmailTemplate,
          default_parent_template: this.defaultParentTemplate,
          qr_code_import_field: this.qrCodeImportField,
          qrCodeImportField_search_type: this.qrCodeImportField_search_type,
          qrCodeImportField_search_field: this.qrCodeImportField_search_field,
          qrCodeImportField_custom_message: this.qrCodeImportField_custom_message,
          qrCodeImportField_error_message: this.qrCodeImportField_error_message,
          qrCodeImportField_success_title: this.qrCodeImportField_success_title,
          qrCodeImportField_error_title: this.qrCodeImportField_error_title,
          consider_as_scheduling: this.consider_as_scheduling,
          perform_actions_without_approval: this.perform_actions_without_approval,
          require_delete_reason: this.require_delete_reason,
          enable_activity_logs: this.enable_activity_logs,
          entity_settings: this.entity_settings,
          view_settings: this.viewSettings,
          enable_bulkActions: this.enable_bulkActions,
          enable_CustomizationMessage: this.enable_CustomizationMessage,
          emailCustomizationFields: this.emailCustomizationFields,
          emailMessageText: this.emailMessageText,
          whenActionSettings: this.whenActionSettings,
          show_entity_hierarchy: this.show_entity_hierarchy,
          whenOptions: this.whenOptions,
          approval_mechanism: this.approval_mechanism,
          login_mode: this.login_mode,
          role_details:
            this.login_mode === 'normal'
              ? null
              : this.roleEntities.map((entityId) => ({
                  roleEntity: entityId,
                  roleName: this.roleConfig[entityId]?.roleName || null,
                  roleLevel: this.roleConfig[entityId]?.roleLevel || null,
                })),
          is_mfa: this.is_mfa,
          external_config: this.integrationConfig,
        };
      },
      getCustomMessageWithIds(message) {
        for (let temp of this.allTemplates) {
          let regex = new RegExp(temp.slug, 'g');
          if (message.match(regex)) {
            message = message.replace(regex, temp._id);
            break;
          }
        }
        return message;
      },
      checkRelationFields() {
        this.showOrphanFieldsError = false;

        this.orphanFields = [];

        let allFieldsMap = {};

        this.allFields.forEach((f) => {
          allFieldsMap[f.key] = f;
        });

        let primaryFieldsMap = {};
        let primaryFieldsIndexMap = {};

        this.primaryFields.forEach((f, index) => {
          primaryFieldsMap[f.key] = f;
          primaryFieldsIndexMap[f.key] = index;
        });

        this.primaryFields.forEach((e) => {
          if (e.input_type == 'ENTITY') {
            let noRleatedFieds = [];
            e.dependent_fields = [];
            if (e.filters && e.filters.length) {
              e.hasRelation = false;

              for (let i = 0; i < e.filters.length; i++) {
                let filter = e.filters[i];
                let hasRelation = filter.field.indexOf('related') > -1;
                if (
                  hasRelation &&
                  !primaryFieldsMap[filter.value_field] &&
                  allFieldsMap[filter.value_field]
                ) {
                  noRleatedFieds.push(allFieldsMap[filter.value_field]);
                } else if (hasRelation && primaryFieldsMap[filter.value_field]) {
                  e.dependent_fields.push(primaryFieldsMap[filter.value_field]);
                }
              }
            }

            if (noRleatedFieds.length) {
              this.orphanFields.push({
                field: e,
                related_reason: 'Should Primary fields have fields Related to',
                related_fields: noRleatedFieds,
              });
            }
          } else if (e.input_type == 'ENTITY_VARIABLE') {
            e.dependent_fields = [];

            if (
              !primaryFieldsMap[e.global_variable_entity_parent] &&
              allFieldsMap[e.global_variable_entity_parent]
            ) {
              this.orphanFields.push({
                field: e,
                related_reason: 'Should Primary fields have fields Related to',
                related_fields: [allFieldsMap[e.global_variable_entity_parent]],
              });
            } else {
              e.dependent_fields = [primaryFieldsMap[e.global_variable_entity_parent]];
            }
          }
        });

        if (this.allFields && this.orphanFields && this.orphanFields.length) {
          this.showOrphanFieldsError = true;
        }
      },

      async sortTheFields() {
        let groups = [];

        let primaryFieldsIndexMap = {};

        this.primaryFields.forEach((f, index) => {
          primaryFieldsIndexMap[f.key] = index;
        });
        this.primaryFields.forEach((a, index) => {
          this.primaryFields.forEach((b, index2) => {
            if (index != index2) {
              if (b.dependent_fields && b.dependent_fields.length) {
                let indexes = b.dependent_fields.map((f) => primaryFieldsIndexMap[f.key]);
                if (indexes.indexOf(index) > -1) {
                  let gIndex = groups.findIndex((g) => g.indexOf(index) > -1);
                  if (gIndex > -1) {
                    groups[gIndex].push(index);
                  } else {
                    groups.push([index2, ...indexes]);
                  }
                }
              }
            }
          });
        });

        let final = [];

        let groupedFlatten = groups.flat();
        let remaining = [...this.primaryFields];
        this.primaryFields.forEach((fled, index) => {
          if (groupedFlatten.indexOf(index) == -1) {
            final.push(fled);
            remaining.splice(index, 1);
          }
        });

        let alreadyDone = [];
        groups = groups.map((e) => {
          e = Array.from(new Set(e)).sort((a, b) => (a > b ? -1 : 1));
          e = e.filter((o) => alreadyDone.indexOf(o) == -1);
          alreadyDone = [...alreadyDone, ...e];
          let ff = e.map((l) => this.primaryFields[l]);
          return ff;
        });

        this.primaryFields = [...final, ...groups.flat()];
      },
      async builderStep(step) {
        try {
          if (this.activeStep != step) {
            this.isSubmit = false;
            this.isSave = false;
            this.isEdit = this.entityId ? true : false;
            if (this.entityName) {
              if (!this.primaryFields.length && step != 1) {
                this.$message.warning(
                  'At least one Primary Field is required to project for the entity information'
                );
                return;
              }
              if (!this.isEdit) {
                if (step == 1) {
                  if (this.selectedEntity && this.selectedEntity.length) {
                    let params = this.prepareParams();
                    await this.$store.dispatch('entities/createNewEntity', params);
                    if (this.getEntityCreatedStatus) {
                      this.$message.success('Successfully added templates to entity');
                      this.activeStep = 1;
                      await this.generateFields();
                    }
                  } else {
                    this.$message.warning('Please choose at least one template');
                  }
                } else if (step == 0) {
                  if (!this.primaryFields.length) {
                    this.$message.warning(
                      'At least one Primary Field is required to project for the entity information'
                    );
                  } else {
                    let params = this.prepareParams();
                    await this.$store.dispatch('entities/createNewEntity', params);
                    if (this.getEntityCreatedStatus) {
                      this.$message.success('Successfully added primary fields to entity');
                      this.activeStep = 0;
                    }
                    this.activeStep = 0;
                  }
                }
              } else {
                if (step == 1) {
                  if (this.selectedEntity && this.selectedEntity.length) {
                    let params = this.prepareParams();
                    await this.$store.dispatch('entities/updateEntityById', params);
                    this.updateLocalEntityData(params.id, params);
                    if (this.getEntityDataUpdateStatus) {
                      this.$message.success('Successfully Updated the templates');

                      this.activeStep = 1;
                      await this.generateFields();
                    }
                  } else {
                    this.$message.warning('Please choose at least one template');
                  }
                } else if (step == 0) {
                  if (!this.primaryFields.length) {
                    this.$message.warning(
                      'At least one Primary Field is required to project for the entity information'
                    );
                  } else {
                    let params = this.prepareParams();
                    await this.$store.dispatch('entities/updateEntityById', params);
                    this.updateLocalEntityData(params.id, params);
                    if (this.getEntityDataUpdateStatus) {
                      this.$message.success('Successfully Updated  primary fields');
                      this.activeStep = 0;
                    }
                  }
                } else if (step == 2) {
                  this.activeStep = 2;
                  // we have to fetch existed relationship
                  await this.setEntityForRelationships();
                } else if (step == 3) {
                  this.activeStep = 3;
                } else if (step == 4) {
                  this.activeStep = 4;
                }
              }
              this.isSubmit = false;
            } else {
              this.$message.warning('Entity name required');
            }
          }
        } catch (err) {
          console.log('builderStep', err);
        }
      },

      async createDocumentTemplate() {
        let params = {
          entity_id: this.getEntityDataById._id,
        };
        if (this.getEntityDataById?.templates?.length == 0) {
          this.$message.error('Please add atleast one form template');
        } else {
          try {
            this.docLoading = true;
            let response = await postAPICall(
              'POST',
              `/entity/document-template/${this.getEntityDataById._id}`,
              params
            );

            if (response.success == true) {
              await this.fetchAllCompanyTemplates();
              let msg = response?.configurableDocument?.name
                ? response.configurableDocument.name +
                  ' document template has been created successfully.'
                : 'Document template has been created successfully.';
              this.$notify.success({
                title: 'Success',
                message: msg,
              });
              this.printingDocuments.push(response.configurableDocumentId);
              this.defaultPrintingDocument = response.configurableDocumentId;
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error while creating document template',
              });
            }
            this.docLoading = false;
          } catch (err) {
            console.log('Error while creating document template', err);
          }
        }
      },

      spanMethod({ row, column, rowIndex, columnIndex }) {
        console.log(row, column, rowIndex, columnIndex);

        if (!this.relationshipsData[rowIndex].is_bidirectional) {
          if (columnIndex === 0) {
            return [0, 4];
          } else if (columnIndex === 1) {
            return [0, 4];
          } else if (columnIndex === 3) {
            return [0, 4];
          } else if (columnIndex === 4) {
            return [0, 4];
          }
        }
      },

      async setEntityForRelationships() {
        this.loading = true;
        const [entities] = await Promise.all([
          fetchEntitiesByPagination({ get_all: true }),
          this.fetchEntityRelationships(),
        ]);
        this.allEntities = [...(entities?.data || [])];
        this.otherEntities = this.allEntities.filter((x) => x._id != this.entityId);

        this.fetchExistedRelationships();

        this.activeStep = 2;

        this.newRelationship = {
          parent_entity_id: this.entityId,
          child_entity_id: '',
          child_relation_title: '',
          child_relation_type: 'MANY',
          parent_relation_title: '',
          parent_relation_type: 'ONE',
          is_bidirectional: true,
          representation: 'TAB',
          apply_limit: false,
          limit_type: 'value',
          limit_value: null,
          limit_field: '',
          warning_message: 'You have reached the limit !',
        };
        this.loading = false;
      },

      async fetchExistedRelationships() {
        this.loading = true;
        this.loadingText = 'Preparing Relationships';
        const allFields = await this.fetchEntityDetails(
          this.getEntityDataById?._id,
          false,
          false,
          false,
          true,
          true,
          true
        );
        allFields.forEach((e) => {
          if (e.inputType == 'ENTITY') {
            if (
              !this.newRelationshipsData.find((x) => x.child_entity_id == e.entity_id) &&
              !this.relationshipsData.find(
                (x) => x.parent_entity_id == e.entity_id || x.child_entity_id == e.entity_id
              ) &&
              this.allEntities.find((x) => x._id == e.entity_id)
            ) {
              let relationship = {
                parent_entity_id: this.$route.params.entity_id,
                child_entity_id: e.entity_id,
                child_relation_title: e.label,
                child_relation_type: e.allow_multiple ? 'MANY' : 'ONE',
                parent_relation_title: this.getEntityDataById?.name
                  ? this.getEntityDataById.name
                  : '',
                parent_relation_type: 'MANY',
                is_bidirectional: true,
                owner_type: 'PARENT',
                representation: 'FIELD',
                field_id: e._id,
                allow_multiple: e.allow_multiple,
                limit_type: 'value',
                limit_value: null,
                limit_field: '',
                warning_message: 'You have reached the limit !',
                apply_limit: false,
              };
              this.newRelationshipsData.push(relationship);
            }
          }
        });
        this.loading = false;
      },
      saveEntity() {
        if (this.activeStep === 0) {
          this.isSave = true;
          this.isSubmit = true;
        } else {
          this.createEntity();
        }
      },
      updateEntityData(close = false) {
        if (this.activeStep === 0) {
          this.isUpdate = true;
          this.isSubmit = true;
        } else {
          if (this.hasUnsavedChanges) {
            this.$message.info(
              'Please save the Tabs Configuration with the newly added modifications.'
            );
          } else {
            this.updateEntity(close);
          }
        }
      },
      async createEntity() {
        if (this.entityName) {
          if (
            this.entityGroupsData &&
            this.entityGroupsData.length &&
            this.entityGroupsData.length > 0
          ) {
            if (this.selectedEntity && this.selectedEntity.length) {
              if (this.activeStep === 1) {
                if (!this.primaryFields.length) {
                  this.$message.warning(
                    'At least one Primary Field is required to project for the entity information'
                  );
                } else {
                  this.save();
                }
              } else {
                this.save();
              }
            } else {
              this.isSubmit = false;
              this.$message.warning('Please add at least one template');
            }
          } else {
            this.isSubmit = false;
            this.loading = false;
          }
        } else {
          this.isSubmit = false;
          this.$message.warning('Entity name required');
        }
      },
      async save() {
        let params = this.prepareParams();
        await this.$store.dispatch('entities/createNewEntity', params);
        if (this.getEntityCreatedStatus) {
          if (this.getEntityCreatedData) {
            addSingleEntityToLocal(this.getEntityCreatedData);
          }
          this.$notify({
            title: 'Success',
            message: 'Successfully added the templates to entity',
            type: 'success',
          });

          if (this.activeStep == 0) {
            this.activeStep = 1;
            await this.generateFields();
          } else if (this.activeStep === 1) {
            this.activeStep = 2;

            if (this.getEntityCreatedData) {
              this.entityId = this.getEntityCreatedData._id;
              await this.setEntityForRelationships();
            }

            return;
          } else if (this.activeStep === 2) {
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              path: `/entity`,
              query: query,
            });
          }
        } else {
          this.$notify({
            title: 'Error',
            message: 'Failed to add the templates',
            type: 'error',
          });
        }
      },
      async update(close = false) {
        try {
          this.loading = true;
          let params = this.prepareParams();
          if (params && params.id && params.id == undefined && this.getEntityDataById?._id) {
            params.id = this.getEntityDataById._id;
          }
          let newTemps = this.selectedEntity.filter(
            (tmp) =>
              !(this.previousTemplates || []).map((t) => t.template_id).includes(tmp.template_id)
          );
          let delTemps = this.previousTemplates.filter(
            (tmp) =>
              !(this.selectedEntity || []).map((t) => t.template_id).includes(tmp.template_id)
          );
          this.previousTemplates = [...JSON.parse(JSON.stringify(this.selectedEntity))];
          if (this.customization?.tab_groups?.length && (newTemps.length || delTemps.length)) {
            if (newTemps.length) {
              this.customization.tab_groups[0].tabs = [
                ...this.customization.tab_groups[0].tabs,
                ...newTemps.map((tmp) => {
                  return {
                    feature_id: tmp.template_id,
                    feature_type: 'TEMPLATE',
                    label: tmp.templateInfo.name,
                  };
                }),
              ];
            }
            if (delTemps.length) {
              let indexesToBeDeleted = {};
              this.customization.tab_groups.map((tab, i) => {
                indexesToBeDeleted[i] = [];
                tab.tabs.map((t, j) => {
                  if (
                    t.feature_type == 'TEMPLATE' &&
                    delTemps.map((tmp) => tmp.template_id).includes(t.feature_id)
                  ) {
                    indexesToBeDeleted[i].push(j);
                  }
                });
              });
              Object.keys(indexesToBeDeleted).map((index) => {
                let indices = indexesToBeDeleted[index].sort((a, b) => b - a);
                indices.map((i) => {
                  this.customization.tab_groups[index].tabs.splice(i, 1);
                });
              });
            }
            await postAPICall('PUT', '/entity-customization/update', this.customization);
          }
          await this.$store.dispatch('entities/updateEntityById', params);
          if (this.getEntityDataUpdateStatus) {
            this.loading = false;
            this.$notify({
              title: 'Success',
              message: 'Entity updated successfully',
              type: 'success',
            });
            this.updateLocalEntityData(params.id, params);
            if (close) {
              let query = this.getNavigationQuery(this.$route.query);
              this.$router.push({
                path: `/entity`,
                query: query,
              });
            } else if (this.activeStep == 0) {
              this.activeStep = 1;
              await this.generateFields();
            } else if (this.activeStep === 1) {
              this.activeStep = 2;
              await this.setEntityForRelationships();
              return;
            } else if (this.activeStep === 2) {
              this.activeStep = 3;
            } else if (this.activeStep === 3) {
              this.activeStep = 4;
            } else if (this.activeStep === 4) {
              let query = this.getNavigationQuery(this.$route.query);
              this.$router.push({
                path: `/entity`,
                query: query,
              });
            }
          } else {
            if (this.getEntityErrors) {
              this.loading = false;
              this.$notify({
                title: 'Error',
                message: 'Entity name already existed.!',
                type: 'error',
              });
            } else {
              this.loading = false;
              this.$notify({
                title: 'Error',
                message: 'Error in updating Entity',
                type: 'error',
              });
            }
          }
        } catch (err) {
          this.loading = false;
          console.log('update', err);
        }
      },
      async addLimit(index) {
        this.parentEntityNumberFields = [];
        this.newRelationship = { ...this.newRelationshipsData[index] };
        if (
          this.newRelationship.representation == 'FIELD' &&
          this.newRelationship.child_relation_type == 'ONE' &&
          !this.newRelationship.allow_multiple
        ) {
          this.newRelationship.apply_limit = true;
          let allFields = await this.fetchEntityDetails(
            this.newRelationship.child_entity_id,
            true,
            true,
            false,
            true,
            true,
            true
          );
          this.parentEntityNumberFields = allFields.filter((e) => e.inputType == 'NUMBER');
          this.editIndex = index;
          this.limitPopup = true;
        } else {
          this.newRelationship.apply_limit = false;
          this.addRelationship(index);
        }
      },
      async addRelationship(index, fromSkip = false) {
        try {
          delete this.newRelationship.allow_multiple;
          this.limitPopup = false;
          if (fromSkip) {
            this.newRelationship.apply_limit = false;
          }
          let status = await this.addNewRelationship();
          if (status) {
            this.newRelationshipsData.splice(index, 1);
          }
        } catch (err) {
          console.log('addRelationship', err);
        }
      },
      prepareRelationshipParams(newRelationship) {
        let params = JSON.parse(JSON.stringify(newRelationship));
        if (params.limit_value == undefined || params.limit_value == null) {
          delete params.limit_value;
        }
        return params;
      },
      async addNewRelationship() {
        this.loading = true;
        this.loadingText = 'Adding Relationship';
        this.checkEntitiesParentTitle(this.newRelationship.child_entity_id);
        let params = this.prepareRelationshipParams(this.newRelationship);
        params['existedIds'] = this.relationshipsData.map((e) => e._id);
        try {
          await this.$store.dispatch('entityRelationships/addEntityRelationship', {
            ...params,
          });
          this.loading = false;

          if (this.getEntityRelationshipAddStatus) {
            this.newRelationship.child_relation_title = '';
            this.newRelationship.parent_relation_title = '';
            this.newRelationship.child_entity_id = '';
            this.$message.success('Entity Relationship added successfully');
            this.fetchEntityRelationships();
          }
          return true;
        } catch (err) {
          this.loading = false;
          console.error('addNewRelationship', err);
          throw err;
        }
      },

      async askRelationDeleteConfirm() {
        return new Promise((resolve) => {
          this.$confirm('Are you sure want to delete relationship ?', 'Alert !', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          })
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        });
      },

      async deleteRelationship(id) {
        try {
          let status = await this.askRelationDeleteConfirm();

          if (status) {
            this.loading = true;

            this.loadingText = 'Deleting Relationship ...';

            await this.$store.dispatch('entityRelationships/deleteEntityRelationship', {
              parent_entity_id: this.$route.params.entity_id,
              entity_relationship_id: id,
            });

            this.loading = false;

            if (this.getEntityRelationshipDeleteStatus) {
              this.$message.success('Entity Relationship removed successfully');
              this.fetchEntityRelationships();
            }
          }
        } catch (err) {
          this.loading = false;
          console.error('deleteRelationship', err);
        }
      },
      getTemplateFields(data) {
        let fields = [];
        data.sections.forEach((e) => {
          fields = [...fields, ...e.fields];
        });
        fields = fields.map((e) => {
          e.template_id = data._id;
          return e;
        });
        return fields;
      },
      async generateFields() {
        if (this.selectedEntity && this.selectedEntity.length) {
          this.allFields = [];
          let allFields = [];
          if (this.primaryFields && this.primaryFields.length) {
            let existedTemplates = this.selectedEntity.flatMap((e) => e.template_id);
            let existedRepeatableTemplate = this.selectedEntity
              .filter((e) => e.is_repeatable)
              .flatMap((e) => e.template_id);
            this.primaryFields = this.primaryFields.filter(
              (e) =>
                existedTemplates.indexOf(e.template_id) != -1 &&
                existedRepeatableTemplate.indexOf(e.template_id) == -1
            );
          }
          await this.selectedEntity.map(async (template) => {
            if (template && template.templateInfo && !template.is_repeatable) {
              allFields = [
                ...allFields,
                ...this.applyCustomizationOnFields(
                  this.getTemplateFields(template.templateInfo),
                  template.customization,
                  template
                ),
              ];
            }
            if (
              template.templateInfo &&
              !template.is_repeatable &&
              template.templateInfo.sections[0].fields
            ) {
              let fields = this.applyCustomizationOnFields(
                template.templateInfo.sections[0].fields,
                template.customization,
                template
              );
              fields.map((field) => {
                let index = this.primaryFields.findIndex(
                  (o) => o.key == field.key && o.template_id == template.templateInfo._id
                );
                if (index === -1) {
                  this.allFields.push({
                    ...field,
                    template_id: template.templateInfo._id,
                    template_slug: template.templateInfo.slug,
                  });
                }
              });
            }
          });
          this.primaryFields = this.primaryFields.map((e) => {
            const matchingField = (allFields || []).find((el) => el.key === e.key);
            if (matchingField && matchingField.label !== e.label) {
              return { ...e, label: matchingField.label };
            }
            return e;
          });
        }
      },
      async fetchTemplates() {
        this.loading = true;
        let params = {
          get_all: true,
          populate_data: true,
          include_standard: true,
        };
        if (this.search_string) {
          params.search_string = this.search_string;
        }
        const getAllCompanyTemplatesData = await getAllCompanyTemplatesByPagination(params);
        this.allTemplates =
          getAllCompanyTemplatesData && getAllCompanyTemplatesData.data
            ? getAllCompanyTemplatesData.data
            : [];
        this.standardTemplate = this.allTemplates.find((e) => e.slug == 'contactdetails');
        this.allTemplates = this.allTemplates.filter((e) => e.slug !== 'contactdetails');
        this.loading = false;
      },

      async fetchEntityRelationships() {
        this.loading = true;
        this.loadingText = 'Fetching Entity relationships..';
        this.fetchedRelationships = await fetchEntityRelationships({
          entity_id: this.$route.params.entity_id,
        });
        this.relationshipsData = [...this.fetchedRelationships];
        // we have to add type owner of relationship

        this.relationshipsData = this.relationshipsData.map((e) => {
          if (e.parent_entity_id == this.$route.params.entity_id) {
            e.owner_type = 'PARENT';
          } else {
            e.owner_type = 'CHILD';
          }
          return e;
        });
        //Fetch entity all template fields
        let allFields = [];
        let allTemplatesFields = await this.fetchEntityDetails(
          this.getEntityDataById?._id,
          false,
          false,
          false,
          true,
          true,
          true
        );
        allTemplatesFields.forEach((field) => {
          if (field.inputType == 'ENTITY') {
            allFields.push(field._id);
          }
        });
        this.relationshipsData = this.relationshipsData.filter((e) => {
          if (
            (e.owner_type == 'CHILD' && !e.is_bidirectional) ||
            (e.representation == 'FIELD' &&
              allFields.indexOf(e.field_id) == -1 &&
              e.parent_entity_id == this.$route.params.entity_id)
          ) {
            return false;
          } else {
            return true;
          }
        });

        this.loading = false;
      },
      checkAutomation() {
        this.saveClicked = !this.saveClicked;
      },
      async goBack() {
        if (this.selectedEntity.length && this.primaryFields.length) {
          let urlPath = '';
          let query = this.getNavigationQuery(this.$route.query);
          urlPath = `/entity`;
          this.$router.push({
            path: urlPath,
            query: query,
          });
        } else {
          this.goBackToEntities = true;
        }
      },
      disableAddLimit() {
        if (this.newRelationship.limit_type == 'field' && this.newRelationship.limit_field == '') {
          return true;
        } else if (
          this.newRelationship.limit_type == 'value' &&
          this.newRelationship.limit_value == null
        ) {
          return true;
        }
        return false;
      },
    },
    watch: {
      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      },
      roleEntities(newEntities) {
        newEntities.forEach((id) => {
          if (!this.roleConfig[id]) {
            this.$set(this.roleConfig, id, { roleName: null, roleLevel: null });
          }
          if (!this.entityFieldsMap[id]) {
            this.fetchFieldsByEntity(id);
          }
        });
        Object.keys(this.roleConfig).forEach((id) => {
          if (!newEntities.includes(id)) {
            this.$delete(this.roleConfig, id);
            this.$delete(this.entityFieldsMap, id);
          }
        });
      },
    },
    beforeDestroy() {
      bus.$off('tabsConfigStatus');
      this.$store.commit('companyTemplates/setAllCompanyTemplatesData', null, {
        root: true,
      });
      this.$store.commit('entities/setEntityCreatedStatus', null, { root: true });
      this.$store.commit('entities/setEntityDataById', null, { root: true });
      this.$store.commit('entities/setEntityDataUpdateStatus', null, {
        root: true,
      });

      this.$store.commit('documents/setAllTemplates', null, { root: true });
      this.$store.commit('entities/setAllEntities', null, { root: true });
      this.$store.commit('entityGroups/setEntityGroupErrors', {}, { root: true });
      this.$store.commit('entityGroups/setSingleEntityGroupData', {}, { root: true });
      this.$store.commit(
        'entityGroups/setAllEntityGroupsData',
        { data: [], total: 0, page: 0 },
        { root: true }
      );
      this.$store.commit('entityRelationships/setEntityRelationships', [], {
        root: true,
      });
      this.$store.commit('entityRelationships/setEntityRelationshipAddStatus', false, {
        root: true,
      });
      this.$store.commit('entityRelationships/setEntityRelationshipDeleteStatus', false, {
        root: true,
      });
    },
  };
</script>

<style lang="scss" scoped>
  .form-label {
    font-weight: 500;
    margin-bottom: 6px;
    display: block;
    font-size: 13px;
    color: #333;
  }

  .login-mode-section {
    margin-top: 10px;
  }

  .scroll {
    scrollbar-width: thin;
    height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .Back-in-Entity {
    margin: 20px;
    height: 80px;
  }

  .actions {
    background: white !important;
  }

  .nameSty {
    font-size: 12px;
    margin-top: -16px;
    margin-left: 1px;
  }

  .inner-navbar {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    z-index: 100;
    background-color: #ffffff;
    border: 1px solid #efefef;
    margin-bottom: 0 !important;

    & > .d-flex {
      .back-btn {
        height: inherit;
      }
    }

    .left-block {
      .el-input__inner {
        min-width: 250px;
        max-width: 300px;
        background: #fff;
        height: 47px;
      }
    }
  }

  .input-type-one {
    font-size: 14px !important;

    &.entity-title-input {
      width: 300px;

      @media (max-width: 1000px) {
        width: 260px;
      }

      @media (max-width: 800px) {
        width: 130px;
      }

      @media (max-width: 500px) {
        width: 60px;
      }

      @media (max-width: 380px) {
        display: none;
      }
    }
  }

  .flow-top-bar {
    display: flex;
    padding: 0px 15px 5px 8px;
    justify-content: space-between;
    align-items: center;

    .left-side {
      display: flex;
      align-items: center;

      .form-title {
        &.hide-title {
          @media (max-width: 400px) {
            display: none;
          }
        }
      }

      .close-icon {
        margin-right: 10px;
        margin-left: 0px;
      }

      .el-step__title.is-process {
        font-weight: 400 !important;
        color: #000577;
      }
    }
  }

  .document-flow {
    min-width: 450px;

    @media (max-width: 1000px) {
      min-width: 420px;
    }

    @media (max-width: 800px) {
      min-width: 300px;
    }

    @media (max-width: 600px) {
      min-width: 180px;
    }

    @media (max-width: 400px) {
      min-width: 150px;
    }

    @media (max-width: 350px) {
      min-width: 120px;
    }
  }

  .document-flow-wrapper {
    min-width: 500px;

    @media (max-width: 1000px) {
      min-width: 500px;
    }

    @media (max-width: 900px) {
      min-width: 350px;
    }

    @media (max-width: 800px) {
      min-width: 300px;
    }

    @media (max-width: 600px) {
      min-width: 200px;
    }

    @media (max-width: 500px) {
      min-width: 180px;
    }

    @media (max-width: 400px) {
      min-width: 162px;
    }

    @media (max-width: 350px) {
      min-width: 162px;
    }
  }

  .flow-top-bar {
    padding: 6px 10px;
    text-align: center;
    border-radius: 12px 12px 0 0;
    justify-content: space-between;

    .flow-top-bar-left-area {
      display: flex;
      align-items: baseline;

      .go-back-link {
      }

      .icon-info-wrapper {
      }
    }

    .flow-top-bar-middle-area {
    }

    .flow-top-bar-right-area {
    }
  }

  .is-mobile {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 85px;
    z-index: 1000;
    background: white;
    color: #ffffff;
    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.05);
    padding: 5px 10px;
    text-align: center;
    justify-content: space-between;

    .flow-top-bar-left-area {
      display: flex;

      .go-back-link {
      }

      .icon-info-wrapper {
      }
    }

    .flow-top-bar-middle-area {
    }

    .document-flow-wrapper {
      min-width: 500px;

      @media (max-width: 1000px) {
        min-width: 500px;
      }

      @media (max-width: 900px) {
        min-width: 350px;
      }

      @media (max-width: 800px) {
        min-width: 300px;
      }

      @media (max-width: 600px) {
        min-width: 200px;
      }

      @media (max-width: 500px) {
        min-width: 180px;
      }

      @media (max-width: 400px) {
        min-width: 162px;
      }

      @media (max-width: 350px) {
        min-width: 162px;
      }
    }

    .flow-top-bar-right-area {
    }
  }

  .close-icon {
    cursor: pointer;
  }

  .dragAndDrop {
    .flip-list-move {
      transition: transform 0.5s;
    }

    .no-move {
      transition: transform 0s;
    }

    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }

    .list-group {
      min-height: 80px;
      max-height: calc(100vh - 300px);
      overflow-y: auto;
      max-width: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      padding-left: 0;
      margin-bottom: 0;
      border-radius: 0.25rem;
      margin: auto;
      scrollbar-width: thin;
    }

    .list-group-item {
      cursor: move;
      color: #4f4f4f;
      font-size: clamp(13px, 0.8vw, 16px);
      font-weight: 400;
      border-radius: 6px;
      border: 1px solid #00000014 !important;
      margin-bottom: 0.5rem;

      &:hover {
        background-color: #f8f8f8;
      }
    }

    .list-group-item i {
      cursor: pointer;
    }

    .dropBox {
      margin: 0.5rem;
      border-radius: 12px;
      border: 1px solid #e9ebec;
      background: #fff;
      padding: 0.75em;

      .head {
        font-size: clamp(13px, 0.8vw, 17px);
        color: #444d5e;
        font-weight: 500;
      }

      .text {
        font-size: clamp(12px, 0.72vw, 15px);
      }

      @media (max-width: 500px) {
        margin: 0px !important;

        .list-group {
          margin: 0px !important;
          max-width: 100% !important;

          .list-group-item {
            padding: 8px 3px;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .entity-information-popup {
    .el-dialog {
      width: 800px;
      padding-bottom: 15px;

      @media (max-width: 800px) {
        width: 700px;
        margin-top: 40px !important;
      }

      @media (max-width: 700px) {
        width: 600px;
        margin-top: 40px !important;
      }

      @media (max-width: 600px) {
        width: 500px;
        margin-top: 40px !important;
      }

      @media (max-width: 500px) {
        width: 400px;
        margin-top: 40px !important;
      }

      @media (max-width: 400px) {
        width: 300px;
        margin-top: 40px !important;
      }

      .entity-type-radio {
        @media (max-width: 400px) {
          & > label {
            & > span {
              padding-left: 5px !important;
              padding-right: 5px !important;
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  #drag-template-background {
    .entity-editor-container {
      position: relative;

      .document-container-wrapper {
        #field-group {
          background: white;
        }

        .form-builder {
          .entity-steps {
            width: calc(100% - 20px);
            margin-left: 10px;
          }
        }

        .el-scrollbar {
          .el-scrollbar__bar {
            &.is-horizontal {
              display: none;
            }
          }
        }
      }

      .right-side-bar {
        background: white;
      }
    }

    .dragAndDrop {
      margin-left: 10%;
      height: calc(100vh - 200px);
      width: calc(100% - 10px);

      .outer-scroll {
        & > .el-scrollbar__bar {
          &.is-horizontal {
            display: none;
          }
        }
      }
    }
  }

  .is-open {
    #drag-template-background {
      .dragAndDrop {
        width: calc(100% - 270px);
      }
    }
  }

  .flow-top-bar {
    .flow-top-bar-middle-area {
      &.document-flow-wrapper {
        .document-flow {
          .el-step__main {
            .el-step__title {
              min-width: 76px !important;
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  // Existing styles...
  @media only screen and (min-width: 1200px) {
    .el-col-lg-4 {
      display: contents;
    }
  }

  .truncate-text {
    white-space: nowrap; // Prevent text from wrapping
    overflow: hidden; // Hide the overflow
    text-overflow: ellipsis; // Add ellipsis (...) for clipped text
  }

  .content-spacing {
    margin: 30px 10px;
  }

  el-button__primary:hover {
    color: var(--primary-contrast-color);
    background-color: var(--brand-500);
    border-color: var(--brand-500);
  }

  .contain-length {
    max-height: 78vh;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .configure-document .form-title .el-input input {
    font-size: 14px !important;
  }

  #drag-template-background .flow-top-bar .left-side .el-input__inner {
    padding-left: 0.5rem !important;
  }

  .view-configuration {
    scrollbar-width: thin;
    overflow: auto;
  }
</style>
